// Auto-generated by apps/home/scripts/load-content.ts — DO NOT EDIT
// DEV-12091: eager subset (shell + homepage) of data.en.ts — the only CMS
// content in the entry chunk. The full data.en.ts is imported lazily.
import type { CMSData } from './types';

const data: CMSData | null = {
  "pages": {
    "shared": {
      "footer_tagline": "The Social Media Sentiment Layer",
      "footer_copyright": "© 2026 LunarCrush. All rights reserved."
    },
    "homepage": {
      "cta_heading": "Ready to build with LunarCrush?",
      "cta_body": "Start integrating real-time social media sentiment into your workflows today. Free tier available.",
      "cta_subtitle": "Free tier for developers · No credit card required",
      "cta_button_label": "GET STARTED",
      "cta_primary_label": "SIGN UP",
      "cta_secondary_label": "VIEW PRICING",
      "data_coverage_label": "04 — COVERAGE",
      "data_coverage_heading": "Where the data comes from",
      "data_depth_label": "03 — DEPTH",
      "data_depth_heading": "The depth behind every asset",
      "data_depth_body": "20+ data points per asset, each with full historical time-series. Here's what that looks like for just one.",
      "data_badge": "Data",
      "data_heading": "The Data Behind the Sentiment",
      "data_body": "We don't guess. We analyze millions of signals across the social web every day to give you the clearest picture of what the market is thinking, feeling, and doing.",
      "data_pipeline_label": "02 — PIPELINE",
      "data_pipeline_heading": "From raw data to actionable signals",
      "data_pipeline_body": "Six layers of processing separate us from any tweet scraper. Every post passes through every layer.",
      "data_scale_label": "01 — SCALE",
      "hero_badge_text": "Now available · LunarCrush for Claude",
      "hero_badge_link": "https://claude.com/connectors/lunarcrush",
      "hero_headline": "The Social Media Sentiment Layer",
      "hero_eyebrow": "Explore what’s happening",
      "hero_subtitle": "Millions of social conversations, analyzed in real time.",
      "hero_cta_label": "GET STARTED",
      "hero_cta_path": "/login",
      "hero_command": "npx @lunarcrush/mcp",
      "hero_button_label": "Install LunarCrush",
      "hero_tabs": "[{\"label\":\"Discover\",\"icon\":\"compass\"},{\"label\":\"Connect\",\"icon\":\"lightning\"},{\"label\":\"Build\",\"icon\":\"code\"}]",
      "hero_connect_platforms": "[{\"name\":\"Claude\",\"prompt\":\"Connect me to the LunarCrush MCP https://claude.ai/directory/837cceff-9820-4510-823f-9bdc5ef21f3a. If not installed help me set up. Use LunarCrush as default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 example prompts I can ask using live social media sentiment.\",\"url\":\"https://claude.ai/new?q=Connect%20me%20to%20the%20LunarCrush%20MCP%20at%20https%3A%2F%2Fclaude.ai%2Fdirectory%2F837cceff-9820-4510-823f-9bdc5ef21f3a.%20If%20it%27s%20not%20installed%2C%20walk%20me%20through%20setup.%20Use%20LunarCrush%20as%20my%20default%20tool%20for%20real-time%20social%20data.%20Let%20me%20know%20if%20I%20need%20an%20account%20to%20access%20full%20data%20https%3A%2F%2Flunarcrush.com%2Fpricing.%20Then%20show%20me%205%20interesting%20example%20prompts%20I%20can%20ask%20using%20live%20social%20media%20sentiment.\"},{\"name\":\"ChatGPT\",\"prompt\":\"Connect me to the LunarCrush MCP. See https://lunarcrush.com/developers/api/ai. If it's not connected, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\",\"url\":\"https://chat.openai.com/?q=%221%20-%20Get%20real-time%20social%20media%20sentiment%20directly%20inside%20ChatGPT%20using%20the%20LunarCrush%20API.%20Docs%20are%20at%20https%3A%2F%2Flunarcrush.com%2Fdevelopers%2Fapi.%0A%0A2%20-%20Connect%20the%20API%20and%20use%20it%20as%20my%20default%20tool%20for%20real-time%20social%20data.%20%0A%0A3%20-%20Inform%20me%20if%20I%20need%20a%20LunarCrush%20account%20to%20get%20all%20of%20the%20API%20data.%20If%20I%20do%20send%20me%20to%20https%3A%2F%2Flunarcrush.com%2Fpricing.%0A%0A4%20-%20Show%20me%20what%20is%20possible.%20Give%20me%20examples%20of%20interesting%20things%20I%20can%20ask%20using%20live%20social%20media%20sentiment%20data%20from%20the%20LunarCrush%20API.%22\"},{\"name\":\"Gemini\",\"prompt\":\"Connect me to the LunarCrush MCP. See https://lunarcrush.com/developers/api/ai. If it's not connected, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\",\"url\":\"https://www.google.com/search?udm=50&aep=11&q=Connect%20me%20to%20the%20LunarCrush%20MCP.%20See%20https%3A%2F%2Flunarcrush.com%2Fdevelopers%2Fapi%2Fai.%20If%20it%27s%20not%20connected%2C%20walk%20me%20through%20setup.%20Use%20LunarCrush%20as%20my%20default%20tool%20for%20real-time%20social%20data.%20Let%20me%20know%20if%20I%20need%20an%20account%20to%20access%20full%20data%20https%3A%2F%2Flunarcrush.com%2Fpricing.%20Then%20show%20me%205%20interesting%20example%20prompts%20I%20can%20ask%20using%20live%20social%20media%20sentiment.\"},{\"name\":\"Grok\",\"prompt\":\"Connect me to the LunarCrush MCP. See https://lunarcrush.com/developers/api/ai. If it's not connected, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\",\"url\":\"https://x.com/i/grok?text=Connect%20me%20to%20the%20LunarCrush%20MCP.%20See%20https%3A%2F%2Flunarcrush.com%2Fdevelopers%2Fapi%2Fai.%20If%20it%27s%20not%20connected%2C%20walk%20me%20through%20setup.%20Use%20LunarCrush%20as%20my%20default%20tool%20for%20real-time%20social%20data.%20Let%20me%20know%20if%20I%20need%20an%20account%20to%20access%20full%20data%20https%3A%2F%2Flunarcrush.com%2Fpricing.%20Then%20show%20me%205%20interesting%20example%20prompts%20I%20can%20ask%20using%20live%20social%20media%20sentiment.\"},{\"name\":\"Perplexity\",\"prompt\":\"Connect me to the LunarCrush MCP. See https://lunarcrush.com/developers/api/ai. If it's not connected, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\",\"url\":\"https://www.perplexity.ai/search/new?q=Connect%20me%20to%20the%20LunarCrush%20MCP.%20See%20https%3A%2F%2Flunarcrush.com%2Fdevelopers%2Fapi%2Fai.%20If%20it%27s%20not%20connected%2C%20walk%20me%20through%20setup.%20Use%20LunarCrush%20as%20my%20default%20tool%20for%20real-time%20social%20data.%20Let%20me%20know%20if%20I%20need%20an%20account%20to%20access%20full%20data%20https%3A%2F%2Flunarcrush.com%2Fpricing.%20Then%20show%20me%205%20interesting%20example%20prompts%20I%20can%20ask%20using%20live%20social%20media%20sentiment.\"},{\"name\":\"Manus\",\"prompt\":\"Connect me to the LunarCrush MCP. See https://lunarcrush.com/developers/api/ai. If it's not connected, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\"},{\"name\":\"Minimax\",\"prompt\":\"Connect me to the LunarCrush MCP. See https://lunarcrush.com/developers/api/ai. If it's not connected, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\"},{\"name\":\"Kimi\",\"prompt\":\"Connect me to the LunarCrush MCP. See https://lunarcrush.com/developers/api/ai. If it's not connected, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\"},{\"name\":\"deepseek\",\"prompt\":\"Connect me to the LunarCrush MCP. See https://lunarcrush.com/developers/api/ai. If it's not connected, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\"}]",
      "hero_build_platforms": "[{\"name\":\"Claude Code\",\"prompt\":\"Connect me to the LunarCrush MCP https://lunarcrush.com/developers/api/ai. If it's not set up, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\"},{\"name\":\"Codex\",\"prompt\":\"Connect me to the LunarCrush MCP https://lunarcrush.com/developers/api/ai. If it's not set up, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\"},{\"name\":\"Cursor\",\"prompt\":\"Connect me to the LunarCrush MCP https://lunarcrush.com/developers/api/ai. If it's not set up, walk me through setup. Use LunarCrush as my default tool for real-time social data. Let me know if I need an account to access full data https://lunarcrush.com/pricing. Then show me 5 interesting example prompts I can ask using live social media sentiment.\"},{\"name\":\"OpenClaw\",\"prompt\":\"Connect the LunarCrush REST API (https://lunarcrush.com/developers/api) as a default data source for real-time social media sentiment. Use Bearer token authentication in the Authorization header.\\n\\nConfigure it so that any query involving:\\ntrending assets\\nsocial momentum\\nsentiment\\nengagement\\nunique creators\\nmindshare\\nnarrative tracking\\ninfluencer attribution\\nautomatically calls the LunarCrush API before any other data source.\\n\\nIf full API data requires an active LunarCrush subscription, inform the user and direct them to: https://lunarcrush.com/pricing\\n\\nAfter connecting, demonstrate example live queries such as:\\nTop trending crypto narratives in the last 6 hours\\nSocial acceleration vs price movement for $BTC\\nSector rotation by social growth\\nTop creators driving engagement for a given asset\\nAnomaly detection in engagement velocity\"},{\"name\":\"LunarCrush API\",\"special\":\"api-preview\"}]",
      "hero_insights_url": "https://lunarcrush.com/home?next=home&initial=false",
      "hero_insights_questions": "[\"What are the top trending crypto narratives right now?\",\"Show me Bitcoin sentiment over the last 7 days\",\"Which creators are driving $SOL engagement?\",\"Compare social volume between $ETH and $BTC\"]",
      "hero_insights_link_label": "View the",
      "hero_insights_link_highlight": "Discover app",
      "hero_api_docs_link_label": "Read the",
      "hero_api_docs_link_highlight": "documentation",
      "hero_api_docs_url": "https://lunarcrush.com/developers/api",
      "trust_label": "Trusted by teams at",
      "hero_trust_label": "INTEGRATED WITH",
      "hero_trust_logos": "[{\"name\":\"Anthropic\",\"logo\":\"/landing-assets/anthropic.svg\",\"height\":17},{\"name\":\"OpenAI\",\"logo\":\"/landing-assets/openai.svg\",\"height\":31},{\"name\":\"Coinbase\",\"logo\":\"/landing-assets/coinbase.svg\",\"height\":16},{\"name\":\"Google\",\"logo\":\"/landing-assets/google.svg\",\"height\":23},{\"name\":\"TradingView\",\"logo\":\"/landing-assets/tradingview.svg\",\"height\":21,\"url\":\"https://www.tradingview.com/\"}]",
      "page_title": "LunarCrush: Social Media Sentiment for Crypto & Stocks",
      "meta_description": "The social media analytics platform powering smarter trades. Track real-time social media sentiment for crypto, stocks, prediction markets and trends.",
      "og_title": "See what the internet is saying about every coin, stock, and social trend",
      "og_description": "Real-time social metrics across crypto, stocks, and prediction markets. The signal layer for traders, funds, and AI agents.",
      "og_type": "website",
      "pricing_badge": "Pricing",
      "pricing_heading": "Simple, transparent pricing",
      "pricing_body": "Pay-as-you-go for the API, or a subscription with the LunarCrush Discover app.",
      "pricing_link_label": "SEE FULL PRICING DETAILS",
      "products_badge": "Products",
      "products_heading": "Extend AI with Real-Time Social Data",
      "products_body": "From AI integrations to API access, a LunarCrush subscription gets you access to all products, plugging you into real-time social media sentiment.",
      "usecases_badge": "Use Cases",
      "usecases_heading": "What do you want to do?",
      "usecases_body": "Find your workflow. Get the tools to execute.",
      "usecases_view_all_label": "VIEW ALL USE CASES"
    },
    "discover": {
      "categories_badge": "Coverage",
      "categories_heading": "50+ categories. Far beyond crypto.",
      "categories_body": "LunarCrush tracks social media sentiment across finance, sports, entertainment, culture, technology, and more.",
      "categories_items": "[{\"icon\":\"₿\",\"title\":\"Cryptocurrencies\",\"sub\":\"4,000+ assets\",\"href\":\"https://lunarcrush.com/home?category=cryptocurrencies\"},{\"icon\":\"📈\",\"title\":\"Stocks & ETFs\",\"sub\":\"2,000+ assets\",\"href\":\"https://lunarcrush.com/home?category=stocks\"},{\"icon\":\"🏀\",\"title\":\"NBA\",\"sub\":\"Teams & players\",\"href\":\"https://lunarcrush.com/home?category=nba\"},{\"icon\":\"🏈\",\"title\":\"NFL\",\"sub\":\"Teams & players\",\"href\":\"https://lunarcrush.com/home?category=nfl\"},{\"icon\":\"⚽\",\"title\":\"Premier League\",\"sub\":\"Clubs & transfers\",\"href\":\"https://lunarcrush.com/home?category=premier-league\"},{\"icon\":\"🏎️\",\"title\":\"Formula 1\",\"sub\":\"Teams & drivers\",\"href\":\"https://lunarcrush.com/home?category=formula-1\"},{\"icon\":\"🎵\",\"title\":\"Musicians\",\"sub\":\"Artists & albums\",\"href\":\"https://lunarcrush.com/home?category=musicians\"},{\"icon\":\"⭐\",\"title\":\"Celebrities\",\"sub\":\"Public figures\",\"href\":\"https://lunarcrush.com/home?category=celebrities\"},{\"icon\":\"👜\",\"title\":\"Fashion & Luxury\",\"sub\":\"Brands & trends\",\"href\":\"https://lunarcrush.com/home?category=fashion\"},{\"icon\":\"💻\",\"title\":\"Technology\",\"sub\":\"Products & brands\",\"href\":\"https://lunarcrush.com/home?category=technology\"},{\"icon\":\"🎮\",\"title\":\"Gaming\",\"sub\":\"Titles & studios\",\"href\":\"https://lunarcrush.com/home?category=gaming\"},{\"icon\":\"🌍\",\"title\":\"Countries\",\"sub\":\"Nations & regions\",\"href\":\"https://lunarcrush.com/home?category=countries\"},{\"icon\":\"✈️\",\"title\":\"Travel\",\"sub\":\"Destinations\",\"href\":\"https://lunarcrush.com/home?category=travel\"},{\"icon\":\"💰\",\"title\":\"VC Firms\",\"sub\":\"Investment firms\",\"href\":\"https://lunarcrush.com/home?category=vc-firms\"},{\"icon\":\"🏟️\",\"title\":\"UFC\",\"sub\":\"Fighters & events\",\"href\":\"https://lunarcrush.com/home?category=ufc\"},{\"icon\":\"🔗\",\"title\":\"50+ More\",\"sub\":\"Explore all →\",\"href\":\"https://lunarcrush.com/home\"}]",
      "comparison_badge": "Choose Your Path",
      "comparison_heading": "Discover is for exploring. API and Claude are for building.",
      "comparison_body": "All powered by the same sentiment layer. Pick the interface that matches how you work.",
      "comparison_discover": "{\"title\":\"Discover\",\"subtitle\":\"Visual exploration. No code.\",\"items\":[\"Browse ranked leaderboards\",\"Search any topic instantly\",\"View trending posts and creators\",\"Build custom watchlists\",\"Chart historical time series\",\"Zero setup required\"]}",
      "comparison_api": "{\"title\":\"API + Claude\",\"subtitle\":\"Programmatic access. Build on top.\",\"items\":[\"REST API for any language\",\"MCP Server for Claude / Claude Code\",\"Build dashboards and agents\",\"Automated monitoring pipelines\",\"Custom data integrations\",\"Enterprise-scale access\"]}",
      "cta_badge": "Ready?",
      "cta_heading": "The conversation is already happening. Now you can see it.",
      "cta_body": "Start exploring real-time social media sentiment across thousands of topics. Free to get started.",
      "cta_button_label": "START EXPLORING",
      "cta_button_href": "https://lunarcrush.com/home",
      "cta_subtitle": "Free tier available. No credit card required.",
      "features_badge": "What You Can Do",
      "features_heading": "More than a dashboard",
      "features_body": "Discover surfaces the social layer behind every asset, topic, and creator.",
      "features_cards": "[{\"icon\":\"🔍\",\"bg\":\"rgba(167,139,250,0.15)\",\"title\":\"Explore Any Topic\",\"desc\":\"Search for any cryptocurrency, stock, brand, celebrity, sports team, or keyword. See real-time sentiment, mention volume, engagement, and the posts driving the conversation.\"},{\"icon\":\"📊\",\"bg\":\"rgba(74,222,128,0.12)\",\"title\":\"Ranked Leaderboards\",\"desc\":\"Sort thousands of assets by Galaxy Score, AltRank, sentiment, social dominance, or engagement. Discover which assets have social momentum before price reacts.\"},{\"icon\":\"👤\",\"bg\":\"rgba(34,211,238,0.12)\",\"title\":\"Creator Discovery\",\"desc\":\"Find the most influential voices on any topic across X, Reddit, YouTube, and TikTok. See who’s driving engagement and shaping narratives.\"},{\"icon\":\"📰\",\"bg\":\"rgba(251,146,60,0.12)\",\"title\":\"Trending Posts Feed\",\"desc\":\"See the most engaged social posts for any topic in real time. Filter by platform, date range, and engagement type. Understand what’s going viral and why.\"},{\"icon\":\"📈\",\"bg\":\"rgba(244,114,182,0.12)\",\"title\":\"Historical Time Series\",\"desc\":\"Chart sentiment, mentions, engagement, and market data over days, weeks, months, or years. Spot patterns in how social activity correlates with price movement.\"},{\"icon\":\"⭐\",\"bg\":\"rgba(96,165,250,0.12)\",\"title\":\"Custom Collections\",\"desc\":\"Build watchlists around your portfolio, research thesis, or interests. Track social activity across your selected assets in one personalized view.\"}]",
      "hero_badge": "LunarCrush Discover",
      "hero_headline": "See what the world is",
      "hero_headline_gradient": "really talking about",
      "hero_description": "Real-time social media sentiment across crypto, stocks, sports, entertainment, brands, and culture. No code. No setup. Just the signal behind the noise.",
      "hero_cta_label": "EXPLORE NOW",
      "hero_cta_href": "https://lunarcrush.com/home",
      "metrics_badge": "Proprietary Metrics",
      "metrics_heading": "Scores you won’t find anywhere else",
      "metrics_body": "LunarCrush processes millions of social posts to produce proprietary metrics that cut through the noise.",
      "metrics_cards": "[{\"score\":\"76\",\"color\":\"#4ade80\",\"label\":\"Galaxy Score™\",\"desc\":\"Combines social activity, sentiment, engagement quality, and market metrics into a single 0–100 score.\"},{\"score\":\"#3\",\"color\":\"#a78bfa\",\"label\":\"AltRank™\",\"desc\":\"Ranks assets by social activity relative to market cap. Surfaces smaller assets with outsized social momentum.\"},{\"score\":\"82%\",\"color\":\"#22d3ee\",\"label\":\"Sentiment\",\"desc\":\"Percentage of positive vs. negative social posts. Spam-filtered. Weighted by creator influence and engagement.\"}]",
      "page_title": "Discover: Trending Crypto, Stocks & Creators | LunarCrush",
      "meta_description": "The LunarCrush Discover app surfaces what's moving across X, Reddit, and news. Track live social metrics across thousands of assets in real time.",
      "og_title": "Find what's trending across crypto, stocks, and creators",
      "og_description": "Real-time social and market signals across thousands of assets. Find alpha before the rest of the market.",
      "og_type": "website",
      "pills_row1": "[{\"label\":\"Bitcoin\",\"color\":\"#fb923c\",\"href\":\"/topic/bitcoin\"},{\"label\":\"Ethereum\",\"color\":\"#22d3ee\",\"href\":\"/topic/ethereum\"},{\"label\":\"Solana\",\"color\":\"#4ade80\",\"href\":\"/topic/solana\"},{\"label\":\"Taylor Swift\",\"color\":\"#f472b6\",\"href\":\"/topic/taylor-swift\"},{\"label\":\"Tesla\",\"color\":\"#60a5fa\",\"href\":\"/topic/tesla\"},{\"label\":\"UFC 310\",\"color\":\"#f87171\",\"href\":\"/topic/ufc\"},{\"label\":\"Premier League\",\"color\":\"#facc15\",\"href\":\"/topic/premier-league\"},{\"label\":\"Apple\",\"color\":\"#a78bfa\",\"href\":\"/topic/apple\",\"icon\":\"https://cdn.lunarcrush.com/others/apple.png\"},{\"label\":\"Drake\",\"color\":\"#4ade80\",\"href\":\"/topic/drake\"},{\"label\":\"Nvidia\",\"color\":\"#fb923c\",\"href\":\"/topic/nvidia\"},{\"label\":\"Formula 1\",\"color\":\"#22d3ee\",\"href\":\"/topic/formula-1\"},{\"label\":\"Louis Vuitton\",\"color\":\"#f472b6\",\"href\":\"/topic/louis-vuitton\"},{\"label\":\"NBA\",\"color\":\"#60a5fa\",\"href\":\"/topic/nba\"},{\"label\":\"XRP\",\"color\":\"#f87171\",\"href\":\"/topic/xrp\"}]",
      "pills_row2": "[{\"label\":\"Dogecoin\",\"color\":\"#facc15\",\"href\":\"/topic/dogecoin\"},{\"label\":\"LeBron James\",\"color\":\"#a78bfa\",\"href\":\"/topic/lebron-james\"},{\"label\":\"Andreessen Horowitz\",\"color\":\"#4ade80\",\"href\":\"/topic/andreessen-horowitz\"},{\"label\":\"NFL\",\"color\":\"#f87171\",\"href\":\"/topic/nfl\"},{\"label\":\"Japan\",\"color\":\"#22d3ee\",\"href\":\"/topic/japan\"},{\"label\":\"Gucci\",\"color\":\"#fb923c\",\"href\":\"/topic/gucci\"},{\"label\":\"Cardano\",\"color\":\"#f472b6\",\"href\":\"/topic/cardano\"},{\"label\":\"Nascar\",\"color\":\"#60a5fa\",\"href\":\"/topic/nascar\"},{\"label\":\"S&P 500\",\"color\":\"#4ade80\",\"href\":\"/topic/sp-500\",\"icon\":\"https://cdn.lunarcrush.com/stocks/spy.png\"},{\"label\":\"Avalanche\",\"color\":\"#f87171\",\"href\":\"/topic/avalanche\"},{\"label\":\"Champions League\",\"color\":\"#facc15\",\"href\":\"/topic/champions-league\"},{\"label\":\"NCAA Football\",\"color\":\"#a78bfa\",\"href\":\"/topic/ncaa-football\"}]",
      "pills_row3": "[{\"label\":\"Amazon\",\"color\":\"#fb923c\",\"href\":\"/topic/amazon\"},{\"label\":\"Polkadot\",\"color\":\"#f472b6\",\"href\":\"/topic/polkadot\"},{\"label\":\"Real Madrid\",\"color\":\"#60a5fa\",\"href\":\"/topic/real-madrid\",\"icon\":\"https://cdn.lunarcrush.com/others/real-madrid-cf.png\"},{\"label\":\"Beyoncé\",\"color\":\"#facc15\",\"href\":\"/topic/beyonce\",\"icon\":\"https://cdn.lunarcrush.com/others/beyonc.png\"},{\"label\":\"Microsoft\",\"color\":\"#4ade80\",\"href\":\"/topic/microsoft\"},{\"label\":\"UFC 311\",\"color\":\"#f87171\",\"href\":\"/topic/ufc\"},{\"label\":\"Chainlink\",\"color\":\"#22d3ee\",\"href\":\"/topic/chainlink\"},{\"label\":\"Liverpool FC\",\"color\":\"#a78bfa\",\"href\":\"/topic/liverpool\"},{\"label\":\"Nike\",\"color\":\"#fb923c\",\"href\":\"/topic/nike\"},{\"label\":\"Polygon\",\"color\":\"#f472b6\",\"href\":\"/topic/polygon\"},{\"label\":\"Super Bowl\",\"color\":\"#60a5fa\",\"href\":\"/topic/super-bowl\"},{\"label\":\"Rihanna\",\"color\":\"#facc15\",\"href\":\"/topic/rihanna\"}]",
      "pills_row4": "[{\"label\":\"Litecoin\",\"color\":\"#22d3ee\",\"href\":\"/topic/litecoin\"},{\"label\":\"MLB\",\"color\":\"#4ade80\",\"href\":\"/topic/mlb\"},{\"label\":\"Samsung\",\"color\":\"#60a5fa\",\"href\":\"/topic/samsung\"},{\"label\":\"Kendrick Lamar\",\"color\":\"#a78bfa\",\"href\":\"/topic/kendrick-lamar\"},{\"label\":\"MMA\",\"color\":\"#f87171\",\"href\":\"/topic/mma\"},{\"label\":\"Tether\",\"color\":\"#4ade80\",\"href\":\"/topic/tether\"},{\"label\":\"Barcelona FC\",\"color\":\"#fb923c\",\"href\":\"/topic/barcelona\"},{\"label\":\"Disney\",\"color\":\"#f472b6\",\"href\":\"/topic/disney\"},{\"label\":\"Uniswap\",\"color\":\"#22d3ee\",\"href\":\"/topic/uniswap\"},{\"label\":\"World Cup\",\"color\":\"#facc15\",\"href\":\"/topic/world-cup\"},{\"label\":\"MrBeast\",\"color\":\"#f87171\",\"href\":\"/topic/mrbeast\"},{\"label\":\"Google\",\"color\":\"#60a5fa\",\"href\":\"/topic/google\"}]",
      "platforms_cards": "[{\"label\":\"X (Twitter)\",\"sub\":\"Posts, replies, quotes\"},{\"label\":\"TikTok\",\"sub\":\"Videos, engagement\"},{\"label\":\"YouTube\",\"sub\":\"Videos, comments\"},{\"label\":\"Reddit\",\"sub\":\"Posts, comments, votes\"},{\"label\":\"Instagram\",\"sub\":\"Posts, reels, stories\"}]",
      "table_badge": "The Platform",
      "table_heading": "Rankings powered by social media sentiment",
      "table_body": "Sort, filter, and explore thousands of assets ranked by what people are actually saying about them, not just their price.",
      "table_tabs": "[\"Cryptocurrencies\",\"Stocks\",\"Prediction Markets\",\"All Topics\"]",
      "table_rows": "[{\"rank\":1,\"name\":\"Bitcoin\",\"ticker\":\"BTC\",\"icon\":\"₿\",\"iconBg\":\"rgba(251,146,60,0.1)\",\"iconColor\":\"#fb923c\",\"sentiment\":82,\"galaxy\":76,\"galaxyColor\":\"#4ade80\",\"mentions\":\"128.4K\",\"engagements\":\"4.28M\",\"change\":\"+3.2%\",\"positive\":true},{\"rank\":2,\"name\":\"Ethereum\",\"ticker\":\"ETH\",\"icon\":\"Ξ\",\"iconBg\":\"rgba(96,165,250,0.1)\",\"iconColor\":\"#60a5fa\",\"sentiment\":74,\"galaxy\":71,\"galaxyColor\":\"#4ade80\",\"mentions\":\"89.1K\",\"engagements\":\"2.91M\",\"change\":\"+1.8%\",\"positive\":true},{\"rank\":3,\"name\":\"Solana\",\"ticker\":\"SOL\",\"icon\":\"◎\",\"iconBg\":\"rgba(167,139,250,0.1)\",\"iconColor\":\"#a78bfa\",\"sentiment\":79,\"galaxy\":68,\"galaxyColor\":\"#4ade80\",\"mentions\":\"64.3K\",\"engagements\":\"1.82M\",\"change\":\"-0.4%\",\"positive\":false},{\"rank\":4,\"name\":\"XRP\",\"ticker\":\"XRP\",\"icon\":\"✕\",\"iconBg\":\"rgba(34,211,238,0.1)\",\"iconColor\":\"#22d3ee\",\"sentiment\":71,\"galaxy\":58,\"galaxyColor\":\"#fb923c\",\"mentions\":\"52.7K\",\"engagements\":\"1.43M\",\"change\":\"+5.1%\",\"positive\":true},{\"rank\":5,\"name\":\"Dogecoin\",\"ticker\":\"DOGE\",\"icon\":\"Ð\",\"iconBg\":\"rgba(250,204,21,0.1)\",\"iconColor\":\"#facc15\",\"sentiment\":68,\"galaxy\":54,\"galaxyColor\":\"#fb923c\",\"mentions\":\"41.2K\",\"engagements\":\"982K\",\"change\":\"+2.6%\",\"positive\":true}]"
    },
    "pricing": {
      "compare_heading": "Compare Plans",
      "faq_heading_light": "We've got answers.",
      "faq_heading_bold": "Questions?",
      "faq_items": "[{\"question\":\"What are the request limits on each plan?\",\"answer\":\"Light: 10 requests/min, 2,000/day. Medium: 100/min, 20,000/day. Heavy: 500/min, 100,000/day. Enterprise: custom. Limits are shared across the API, MCP, and CLI.\"},{\"question\":\"What happens if I go over my limit?\",\"answer\":\"Requests over the limit return a rate-limit error (429) and are not billed. Upgrade anytime to raise your limits.\"},{\"question\":\"How do I try LunarCrush?\",\"answer\":\"Pay-as-you-go is the lightest way in: an API key with 1,000 credits to start, then $1 per 1,000 requests across the API, MCP, and CLI. The LunarCrush Discover app comes with a subscription; the daily plan is the low-cost way to try one. Trials exist on Enterprise.\"},{\"question\":\"Is my payment information secure?\",\"answer\":\"Yes. All payment information is encrypted and processed through Stripe, a PCI-DSS Level 1 certified payment processor. LunarCrush never stores your full credit card details on our servers.\"},{\"question\":\"Can I cancel my subscription at any time?\",\"answer\":\"Absolutely. You can cancel your subscription at any time from your account settings. Your access will continue until the end of your current billing period.\"},{\"question\":\"What categories and metrics are included in a LunarCrush subscription?\",\"answer\":\"All plans include access to social metrics across cryptocurrencies, stocks, and 50+ topic categories. Metrics include Galaxy Score, AltRank, social volume, sentiment, social dominance, and more.\"},{\"question\":\"What payment methods do you accept for plan subscriptions?\",\"answer\":\"We accept all major credit and debit cards (Visa, Mastercard, American Express). Cryptocurrency payments are not currently supported.\"},{\"question\":\"What happens to my account if my payment fails?\",\"answer\":\"If a payment fails, we will retry the charge and notify you via email. You will have a grace period to update your payment information before your account is downgraded.\"},{\"question\":\"Can I get a refund?\",\"answer\":\"Payments are final and non-refundable. You retain access through your billing period after cancellation.\"},{\"question\":\"Can I use LunarCrush data commercially?\",\"answer\":\"Yes, but within the limits of your selected plan. Reach out to our team to discuss how we can support your project further.\"},{\"question\":\"Can I change my plan later if I want to upgrade or downgrade?\",\"answer\":\"Yes. You can upgrade or downgrade your plan at any time. When upgrading, you will be charged the prorated difference. When downgrading, the change takes effect at the start of your next billing cycle.\"},{\"question\":\"What is the difference between Priority and Premium support?\",\"answer\":\"Priority support (Medium plan) provides 24-hour response times via email and chat during weekday business hours. Premium support (Heavy plan) provides 4-hour response times via email, chat, and phone with the fastest response rate.\"}]",
      "hero_description": "Coverage across X, Reddit, YouTube, TikTok, Instagram and news, daily history back to January 2020, and continuous real-time updates.",
      "hero_headline": "Real-time social media sentiment for research, decisions, and AI",
      "hero_badge": "Pricing",
      "page_title": "LunarCrush Pricing: Plans for Traders, Devs & Enterprise",
      "meta_description": "Compare LunarCrush plans. Individual at $90/mo, Builder at $300/mo, Scale at $900/mo. All plans include MCP access for Claude, ChatGPT, Gemini and more.",
      "og_title": "Plans for traders, builders, and enterprises",
      "og_description": "Individual at $90/mo. Builder at $300/mo. Scale at $900/mo. Enterprise custom. Every plan includes MCP access for Claude, ChatGPT, and Gemini.",
      "og_type": "website",
      "testimonials_heading_light": "LunarCrush",
      "testimonials_heading_bold": "Why They Choose",
      "testimonials_items": "[{\"name\":\"Tim Draper\",\"handle\":\"@TimDraper\",\"avatar\":\"/landing-assets/tim-draper.png\",\"quote\":\"LunarCrush provides the social intelligence that retail investors in crypto need to make smart, timely decisions. They've consistently spotted market shifts early, including an advance signal on the collapse of Silicon Valley Bank.\"},{\"name\":\"The Wolf of All Streets\",\"handle\":\"@scottmelker\",\"avatar\":\"/landing-assets/scott-melker.png\",\"quote\":\"It's not just about data; it's about intelligent, actionable insights that empower better decisions across the board. With LunarCrush, we're not just observing trends — we're anticipating them, giving us a real edge in a fast-moving market.\"}]"
    }
  },
  "products": [
    {
      "name": "LunarCrush + Claude",
      "description": "Bring social data directly into your Claude AI workflow. Chat and build with real-time social media sentiment.",
      "icon": "code",
      "accentColor": "slate",
      "previewUrl": "https://claude.ai/new?q=Connect%20me%20to%20the%20LunarCrush%20MCP%20at%20https%3A%2F%2Fclaude.ai%2Fdirectory%2F837cceff-9820-4510-823f-9bdc5ef21f3a.%20If%20it%27s%20not%20installed%2C%20walk%20me%20through%20setup.%20Use%20LunarCrush%20as%20my%20default%20tool%20for%20real-time%20social%20data.%20Let%20me%20know%20if%20I%20need%20an%20account%20to%20access%20full%20data%20https%3A%2F%2Flunarcrush.com%2Fpricing.%20Then%20show%20me%205%20interesting%20example%20prompts%20I%20can%20ask%20using%20live%20social%20media%20sentiment.",
      "learnMoreUrl": "/products/lunarcrush-claude",
      "order": 1
    },
    {
      "name": "LunarCrush API",
      "description": "Programmatic access to social and market data across financial markets, sports, brands, and trending topics.",
      "icon": "code",
      "accentColor": "slate",
      "previewUrl": "https://lunarcrush.com/developers/api",
      "learnMoreUrl": "/products/lunarcrush-api",
      "order": 2
    },
    {
      "name": "LunarCrush CLI",
      "description": "Access real-time social media sentiment from your terminal. Markdown, JSON, or CSV — one command, every format.",
      "icon": "terminal",
      "accentColor": "slate",
      "previewUrl": "https://lunarcrush.ai/cli",
      "learnMoreUrl": "/products/lunarcrush-cli",
      "order": 3
    },
    {
      "name": "LunarCrush MCP Server",
      "description": "Boost your AI experience by connecting any agent or MCP-compatible client to real-time social media sentiment with a single URL.",
      "icon": "lightning",
      "accentColor": "slate",
      "previewUrl": "https://lunarcrush.ai/",
      "learnMoreUrl": "/products/lunarcrush-mcpserver",
      "order": 3
    },
    {
      "name": "LunarCrush Discover",
      "description": "Explore trending topics, emerging social narratives, and sentiment shifts across crypto, stocks and more.",
      "icon": "compass",
      "accentColor": "slate",
      "previewUrl": "https://lunarcrush.com/home",
      "learnMoreUrl": "/products/lunarcrush-discover",
      "order": 4
    },
    {
      "name": "LunarCrush Collections",
      "description": "Build tailored data streams across any combination of assets and topics. Your data, organized your way.",
      "icon": "stack",
      "accentColor": "slate",
      "previewUrl": "https://lunarcrush.com/collections",
      "learnMoreUrl": "/products/lunarcrush-custom-collections",
      "order": 5
    }
  ],
  "useCases": [
    {
      "title": "Find Top Coins by Galaxy Score™",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by Galaxy Score™",
        "claude": "What are the top 10 cryptocurrencies by Galaxy Score™ right now?",
        "claudeCode": "Cryptocurrencies(sort='galaxy_score', limit=10)",
        "api": "GET /coins/list/v1?sort=galaxy_score"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score",
      "primaryMetric": "Galaxy Score™",
      "tags": "trending, discovery, scoring, health, social-market",
      "order": 1,
      "description": "Identify the healthiest coins by combined social engagement and market performance using Galaxy Score™."
    },
    {
      "title": "Find Top Crypto by Galaxy Score™",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by Galaxy Score™",
        "claude": "What are the top 10 cryptocurrencies by Galaxy Score™ right now?",
        "claudeCode": "Cryptocurrencies(sort='galaxy_score', limit=10)",
        "api": "GET /coins/list/v1?sort=galaxy_score"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score",
      "primaryMetric": "Galaxy Score™",
      "tags": "trending, discovery, scoring, health, social-market",
      "order": 1,
      "description": "Identify the healthiest coins by combined social engagement and market performance using Galaxy Score™."
    },
    {
      "title": "Find Top Coins by AltRank™",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by AltRank™",
        "claude": "Which coins have the best AltRank™ right now?",
        "claudeCode": "Cryptocurrencies(sort='alt_rank', limit=10)",
        "api": "GET /coins/list/v1?sort=alt_rank"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=alt_rank&sort=alt_rank",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=alt_rank",
      "primaryMetric": "AltRank™",
      "tags": "ranking, relative-performance, outperformers",
      "order": 2,
      "description": "Discover coins outperforming all others by combined social + market activity relative to peers."
    },
    {
      "title": "Find Top Crypto by AltRank™",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by AltRank™",
        "claude": "Which coins have the best AltRank™ right now?",
        "claudeCode": "Cryptocurrencies(sort='alt_rank', limit=10)",
        "api": "GET /coins/list/v1?sort=alt_rank"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=alt_rank&sort=alt_rank",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=alt_rank",
      "primaryMetric": "AltRank™",
      "tags": "ranking, relative-performance, outperformers",
      "order": 2,
      "description": "Discover coins outperforming all others by combined social + market activity relative to peers."
    },
    {
      "title": "Find Coins with Highest Trading Volume",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Trading",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by Trading Volume",
        "claude": "What are the top coins by 24h trading volume right now?",
        "claudeCode": "Cryptocurrencies(sort='volume_24h', limit=10)",
        "api": "GET /coins/list/v1?sort=volume_24h"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=volume_24h&sort=volume_24h",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=volume_24h",
      "primaryMetric": "Volume",
      "tags": "volume, trading, liquidity",
      "order": 3,
      "description": "Screen for coins with the most trading activity, combined with social context."
    },
    {
      "title": "Screen Crypto by Sector",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sector filter dropdown",
        "claude": "Show me the top AI tokens by Galaxy Score",
        "claudeCode": "Cryptocurrencies(sort='galaxy_score', sector='ai', limit=20)",
        "api": "GET /coins/list/v2?sort=galaxy_score&filter=ai&limit=20"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score&filter=ai",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score&filter=ai&limit=20",
      "primaryMetric": "Galaxy Score",
      "tags": "sector, filtering, defi, ai, meme, gaming, layer-1",
      "order": 3,
      "description": "Filter coins by sector (DeFi, AI, Meme, Layer-1, Gaming, etc.) and rank by any metric."
    },
    {
      "title": "Find Memecoins with Real Social Traction",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: Meme > Sort by Engagements",
        "claude": "Which meme coins have the highest social engagement and positive sentiment?",
        "claudeCode": "Cryptocurrencies(sort='interactions', sector='meme', limit=20)",
        "api": "GET /coins/list/v2?sort=interactions&filter=meme&limit=20&desc=1"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=interactions&sort=interactions&filter=meme",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=interactions&filter=meme&limit=20&desc=1",
      "primaryMetric": "Interactions",
      "tags": "meme, engagement, hype-vs-signal, sentiment",
      "order": 4,
      "description": "Separate hype from signal by ranking meme coins by engagement, sentiment, and Galaxy Score."
    },
    {
      "title": "Track Crypto Mention Trends Over Time",
      "audience": "Investors",
      "dataType": "Time Series",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Search any coin > Time Series tab",
        "claude": "Show me how Bitcoin social mentions have trended over the last 30 days",
        "claudeCode": "Topic_Time_Series(topic='bitcoin', bucket='day', interval='1m')",
        "api": "GET /topic/bitcoin/time-series/v1?bucket=day&interval=1m"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=bitcoin",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/bitcoin/time-series/v1?bucket=day&interval=1m",
      "primaryMetric": "Mentions",
      "tags": "mentions, time-series, trends, narrative",
      "order": 4,
      "description": "See how social mentions for any coin change over days, weeks, and months to spot emerging narratives."
    },
    {
      "title": "Track Cryptocurrency Mention Trends Over Time",
      "audience": "Investors",
      "dataType": "Time Series",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Search any coin > Time Series tab",
        "claude": "Show me how Bitcoin social mentions have trended over the last 30 days",
        "claudeCode": "Topic_Time_Series(topic='bitcoin', bucket='day', interval='1m')",
        "api": "GET /topic/bitcoin/time-series/v1?bucket=day&interval=1m"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=bitcoin",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/bitcoin/time-series/v1?bucket=day&interval=1m",
      "primaryMetric": "Mentions",
      "tags": "mentions, time-series, trends, narrative",
      "order": 4,
      "description": "See how social mentions for any coin change over days, weeks, and months to spot emerging narratives."
    },
    {
      "title": "Discover AI Agent Tokens",
      "audience": "Investors, Builders",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: AI Agents",
        "claude": "What are the top AI agent tokens by social engagement?",
        "claudeCode": "Cryptocurrencies(sort='galaxy_score', sector='ai-agents')",
        "api": "GET /coins/list/v2?sort=galaxy_score&filter=ai-agents&limit=20"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score&filter=ai-agents",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score&filter=ai-agents&limit=20",
      "primaryMetric": "Galaxy Score",
      "tags": "ai-agents, emerging-sector, discovery",
      "order": 5,
      "description": "Track the emerging AI Agents sector with social and market rankings."
    },
    {
      "title": "Spot Social Dominance Shifts",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by Social Dominance",
        "claude": "Which cryptocurrencies have the highest social dominance right now?",
        "claudeCode": "Cryptocurrencies(sort='social_dominance', limit=10)",
        "api": "GET /coins/list/v1?sort=social_dominance"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=social_dominance&sort=social_dominance",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=social_dominance",
      "primaryMetric": "Social Dominance",
      "tags": "dominance, market-share, narrative-shift",
      "order": 5,
      "description": "Find which coins are gaining or losing share of overall crypto social conversation."
    },
    {
      "title": "Detect Unusual Engagement Spikes",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Trading",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by Interactions (24h)",
        "claude": "Which coins have unusual engagement spikes in the last 24 hours?",
        "claudeCode": "Cryptocurrencies(sort='interactions_24h', limit=10)",
        "api": "GET /coins/list/v1?sort=interactions_24h"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=interactions_24h&sort=interactions_24h",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=interactions_24h",
      "primaryMetric": "Engagements",
      "tags": "spikes, anomaly, early-signal, momentum",
      "order": 6,
      "description": "Find coins where social engagement is spiking far above their normal baseline — early signal for momentum."
    },
    {
      "title": "Find Coins Gaining Social Dominance",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by Social Dominance",
        "claude": "Which crypto assets have the highest social dominance right now?",
        "claudeCode": "Cryptocurrencies(sort='social_dominance', limit=20)",
        "api": "GET /coins/list/v2?sort=social_dominance&limit=20&desc=1"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=social_dominance&sort=social_dominance",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=social_dominance&limit=20&desc=1",
      "primaryMetric": "Social Dominance",
      "tags": "attention-share, dominance, narrative-tracking",
      "order": 6,
      "description": "Identify which coins are commanding an increasing share of all social conversation."
    },
    {
      "title": "Compare Sentiment Across Competing L1s",
      "audience": "Investors",
      "dataType": "Sentiment",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Search each L1 > Compare sentiment scores",
        "claude": "Compare the sentiment for Ethereum, Solana, Avalanche, and Cardano right now",
        "claudeCode": "Topic(topic='ethereum') vs Topic(topic='solana') > sentiment",
        "api": "GET /topic/{symbol}/v1 for each L1 > compare sentiment fields"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=ethereum",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/ethereum/v1",
      "primaryMetric": "Sentiment",
      "tags": "comparison, layer-1, sentiment, competitive",
      "order": 7,
      "description": "Side-by-side sentiment comparison for Layer 1 blockchains to gauge market preference."
    },
    {
      "title": "Spot Coins with Biggest 24h Price Moves",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Trading",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by 24h %",
        "claude": "Which coins had the biggest price moves in the last 24 hours?",
        "claudeCode": "Cryptocurrencies(sort='percent_change_24h', limit=20)",
        "api": "GET /coins/list/v2?sort=percent_change_24h&limit=20&desc=1"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=percent_change_24h&sort=percent_change_24h",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=percent_change_24h&limit=20&desc=1",
      "primaryMetric": "Price Change 24h",
      "tags": "price-movers, volatility, trading",
      "order": 7,
      "description": "Rank coins by 24-hour price change alongside social data to understand what's driving moves."
    },
    {
      "title": "Find Rising Coins Before They Trend",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Trading",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by Social Score change",
        "claude": "Which coins have the fastest growing social activity but haven't moved in price yet?",
        "claudeCode": "Cryptocurrencies(sort='social_score', limit=20) > filter by low price_change",
        "api": "GET /coins/list/v1?sort=social_score"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=social_score&sort=social_score",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=social_score",
      "primaryMetric": "Social Score",
      "tags": "early-discovery, divergence, alpha, pre-trend",
      "order": 8,
      "description": "Identify coins with rapidly increasing social activity that haven't yet moved in price."
    },
    {
      "title": "Monitor Real-Time Sentiment for Any Asset",
      "audience": "Investors, Enterprise",
      "dataType": "Sentiment",
      "assetClass": "Crypto, Stocks",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Search any asset > View sentiment breakdown by platform",
        "claude": "What is the current sentiment around Ethereum across all social platforms?",
        "claudeCode": "Topic(topic='ethereum') > types_sentiment",
        "api": "GET /topic/ethereum/v1 > types_sentiment"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=sentiment&sort=sentiment",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/ethereum/v1",
      "primaryMetric": "Sentiment",
      "tags": "sentiment, per-platform, bullish-bearish",
      "order": 9,
      "description": "Track % of positive vs negative social posts (weighted by engagement) across X, Reddit, YouTube, TikTok, News."
    },
    {
      "title": "Compare Sentiment Across Platforms",
      "audience": "Enterprise, Creators",
      "dataType": "Sentiment",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Topic page > Sentiment by network section",
        "claude": "Compare Bitcoin sentiment on X vs Reddit vs YouTube right now",
        "claudeCode": "Topic(topic='bitcoin') > types_sentiment_detail",
        "api": "GET /topic/bitcoin/v1 > types_sentiment_detail"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=bitcoin",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/bitcoin/v1",
      "primaryMetric": "Sentiment",
      "tags": "platform-comparison, cross-platform, sentiment-breakdown",
      "order": 10,
      "description": "See how sentiment differs between X, Reddit, YouTube, TikTok, and News for any topic."
    },
    {
      "title": "Track Sentiment Trends Over Time",
      "audience": "Investors, Enterprise",
      "dataType": "Time Series",
      "assetClass": "Crypto, Stocks",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Topic page > Time-series chart > Sentiment overlay",
        "claude": "How has Solana sentiment changed over the past month?",
        "claudeCode": "Topic_Time_Series(topic='solana', interval='1m', metrics=['sentiment'])",
        "api": "GET /topic/solana/time-series/v2?bucket=day&interval=1m"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=solana",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/solana/time-series/v1?bucket=day&interval=1m",
      "primaryMetric": "Sentiment",
      "tags": "trend, historical, sentiment-shift",
      "order": 11,
      "description": "Monitor how sentiment around any asset changes over days, weeks, or months."
    },
    {
      "title": "Find Coins with Highest Sentiment",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by Sentiment",
        "claude": "Which cryptocurrencies have the most positive sentiment right now?",
        "claudeCode": "Cryptocurrencies(sort='sentiment', limit=20)",
        "api": "GET /coins/list/v2?sort=sentiment&limit=20&desc=1"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=sentiment&sort=sentiment",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=sentiment&limit=20&desc=1",
      "primaryMetric": "Sentiment",
      "tags": "bullish, positive-narrative, community-conviction",
      "order": 12,
      "description": "Rank all cryptocurrencies by overall sentiment score to find the most bullish narratives."
    },
    {
      "title": "Detect Social Engagement Spikes",
      "audience": "Investors, Builders",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Trading",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Sort by Engagements",
        "claude": "Which coins had the biggest social engagement spike in the last 24 hours?",
        "claudeCode": "Cryptocurrencies(sort='interactions', limit=20)",
        "api": "GET /coins/list/v2?sort=interactions&limit=20&desc=1"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=interactions&sort=interactions",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=interactions&limit=20&desc=1",
      "primaryMetric": "Interactions",
      "tags": "spike-detection, early-signal, engagement-surge",
      "order": 13,
      "description": "Find assets where social interactions are surging abnormally, often preceding price moves."
    },
    {
      "title": "Track Social Mentions Volume",
      "audience": "Enterprise, Creators",
      "dataType": "Time Series",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Topic page > Posts active chart",
        "claude": "How many social mentions did Bitcoin get in the last week?",
        "claudeCode": "Topic_Time_Series(topic='bitcoin', interval='1w', metrics=['posts_active'])",
        "api": "GET /topic/bitcoin/time-series/v2?interval=1w"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=bitcoin",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/bitcoin/time-series/v1?interval=1w",
      "primaryMetric": "Posts Active",
      "tags": "mention-volume, social-volume, buzz-tracking",
      "order": 14,
      "description": "Monitor how many unique social posts mention a specific asset across all platforms."
    },
    {
      "title": "Count Unique Social Contributors",
      "audience": "Enterprise",
      "dataType": "Time Series",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Topic page > Contributors chart",
        "claude": "How many unique creators are posting about Ethereum today?",
        "claudeCode": "Topic_Time_Series(topic='ethereum', metrics=['contributors_active'])",
        "api": "GET /topic/ethereum/time-series/v2"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=ethereum",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/ethereum/time-series/v1",
      "primaryMetric": "Contributors Active",
      "tags": "contributor-breadth, organic-vs-botted, unique-posters",
      "order": 15,
      "description": "See how many unique accounts are posting about a topic, distinguishing broad vs concentrated buzz."
    },
    {
      "title": "Identify Spam Volume Around a Topic",
      "audience": "Investors, Enterprise",
      "dataType": "Time Series",
      "assetClass": "Crypto",
      "workflow": "Risk",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "lunarcrush.com > Topic page > Spam indicator",
        "claude": "What is the spam volume around Shiba Inu right now?",
        "claudeCode": "Topic_Time_Series(topic='shiba inu', metrics=['spam'])",
        "api": "GET /topic/shiba inu/time-series/v2"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=shiba%20inu",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/shiba inu/time-series/v1",
      "primaryMetric": "Spam",
      "tags": "spam, manipulation, bot-detection, risk",
      "order": 16,
      "description": "Monitor how much spam is being generated for a topic to gauge manipulation risk."
    },
    {
      "title": "Find Top Creators for Any Topic",
      "audience": "Creators, Enterprise",
      "dataType": "Creator Rankings",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Topic page > Creators section",
        "claude": "Who are the top 10 creators talking about Bitcoin right now?",
        "claudeCode": "Fetch(id='topic/bitcoin/creators')",
        "api": "GET /topic/bitcoin/creators/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=bitcoin",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/bitcoin/creators/v1",
      "primaryMetric": "Creator Rank",
      "tags": "influencers, kol, creator-discovery",
      "order": 17,
      "description": "Discover the most influential social accounts driving conversation around any asset or topic."
    },
    {
      "title": "View Global Creator Leaderboard",
      "audience": "Creators, Enterprise",
      "dataType": "Creator Rankings",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Creators leaderboard",
        "claude": "Who are the top social media creators globally by engagement?",
        "claudeCode": "Fetch(id='creators/list')",
        "api": "GET /creators/list/v1"
      },
      "discoverUrl": "https://lunarcrush.com/creators",
      "apiUrl": "https://lunarcrush.com/developers/api/public/creators/list/v1",
      "primaryMetric": "Creator Rank",
      "tags": "leaderboard, global-ranking, top-creators",
      "order": 18,
      "description": "See the most engaged social accounts across all topics worldwide."
    },
    {
      "title": "Analyze a Specific Creator's Profile",
      "audience": "Creators, Enterprise",
      "dataType": "Creator Detail",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Search for @handle",
        "claude": "Show me @elonmusk's social influence and topic impact",
        "claudeCode": "Creator(screenName='elonmusk')",
        "api": "GET /creator/twitter/elonmusk/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/creator/twitter/elonmusk/v1",
      "primaryMetric": "Creator Rank",
      "tags": "creator-profile, influence-audit, kol-analysis",
      "order": 19,
      "description": "Deep-dive into any creator's followers, engagement, rank, and which topics they influence."
    },
    {
      "title": "Track Creator Engagement Over Time",
      "audience": "Creators, Enterprise",
      "dataType": "Time Series",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Creator profile > Time-series charts",
        "claude": "Show me @VitalikButerin's engagement trend over the past month",
        "claudeCode": "Fetch(id='creator/twitter/VitalikButerin/time-series')",
        "api": "GET /creator/twitter/VitalikButerin/time-series/v1?interval=1m"
      },
      "discoverUrl": "https://lunarcrush.com/creators",
      "apiUrl": "https://lunarcrush.com/developers/api/public/creator/twitter/VitalikButerin/time-series/v1?interval=1m",
      "primaryMetric": "Interactions",
      "tags": "creator-growth, engagement-trend, follower-tracking",
      "order": 20,
      "description": "Monitor how a creator's engagement and follower count changes over weeks or months."
    },
    {
      "title": "See a Creator's Top Posts",
      "audience": "Creators, Enterprise",
      "dataType": "Posts",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Creator profile > Posts tab",
        "claude": "What are @lunarcrush's top posts by engagement?",
        "claudeCode": "Fetch(id='creator/twitter/lunarcrush/posts')",
        "api": "GET /creator/twitter/lunarcrush/posts/v1"
      },
      "discoverUrl": "https://lunarcrush.com/creators",
      "apiUrl": "https://lunarcrush.com/developers/api/public/creator/twitter/lunarcrush/posts/v1",
      "primaryMetric": "Interactions Total",
      "tags": "top-content, best-posts, content-analysis",
      "order": 21,
      "description": "View the most engaging posts from any specific creator, ranked by total interactions."
    },
    {
      "title": "Find Crypto KOLs for Partnership Outreach",
      "audience": "Enterprise, Builders",
      "dataType": "Creator Rankings",
      "assetClass": "Crypto",
      "workflow": "Marketing",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Crypto topic > Creators section > Filter by engagement",
        "claude": "Who are the top creators talking about DeFi right now?",
        "claudeCode": "Fetch(id='topic/defi/creators')",
        "api": "GET /topic/defi/creators/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=defi",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/defi/creators/v1",
      "primaryMetric": "Creator Rank",
      "tags": "partnership, marketing, kol-outreach, sponsorship",
      "order": 22,
      "description": "Identify top creators in crypto sub-sectors for marketing, partnerships, or sponsorship."
    },
    {
      "title": "View Globally Trending Social Topics",
      "audience": "Builders, Enterprise",
      "dataType": "Rankings",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Browse all categories and topics",
        "claude": "What are the top trending social topics right now?",
        "claudeCode": "List(limit=20)",
        "api": "GET /topics/list/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topics/list/v1",
      "primaryMetric": "TopicRank",
      "tags": "trending, global-topics, social-trends",
      "order": 23,
      "description": "See what topics are trending across all of social media (not just crypto)."
    },
    {
      "title": "Browse Trending Topics by Category",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Select a category (e.g. Musicians, NBA)",
        "claude": "Which musicians are trending the most on social media today?",
        "claudeCode": "List(category='musicians', sort='topic_rank', limit=20)",
        "api": "GET /category/musicians/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/musicians/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "category-browse, musicians, nba, gaming, brands",
      "order": 24,
      "description": "Drill into specific categories: Musicians, NBA, Technology Brands, Gaming, Countries, etc."
    },
    {
      "title": "Track Category-Level Social Metrics",
      "audience": "Enterprise",
      "dataType": "Time Series",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Category page > Aggregate metrics",
        "claude": "How has social engagement in the cryptocurrency category changed this month?",
        "claudeCode": "Fetch(id='category/cryptocurrencies/time-series')",
        "api": "GET /category/cryptocurrencies/time-series/v1?bucket=day"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/cryptocurrencies/time-series/v1?bucket=day",
      "primaryMetric": "Interactions",
      "tags": "category-level, aggregate, macro-trends",
      "order": 25,
      "description": "Monitor aggregate engagement, sentiment, and contributor counts for an entire category."
    },
    {
      "title": "Compare Category Rankings",
      "audience": "Enterprise",
      "dataType": "Rankings",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories overview",
        "claude": "Which social categories have the most engagement right now?",
        "claudeCode": "Fetch(id='categories/list')",
        "api": "GET /categories/list/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/categories/list/v1",
      "primaryMetric": "Category Rank",
      "tags": "cross-category, attention-mapping, macro",
      "order": 26,
      "description": "See how all categories rank against each other by social engagement."
    },
    {
      "title": "Find Top Posts for Any Topic",
      "audience": "Creators, Investors",
      "dataType": "Posts",
      "assetClass": "Any",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Topic page > Posts section",
        "claude": "What are the top posts about Ethereum in the last 24 hours?",
        "claudeCode": "Topic_Posts(topic='ethereum')",
        "api": "GET /topic/ethereum/posts/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=ethereum",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/ethereum/posts/v1",
      "primaryMetric": "Interactions 24h",
      "tags": "viral-posts, top-content, content-discovery",
      "order": 27,
      "description": "Surface the actual tweets, videos, TikToks, and Reddit threads driving the most engagement."
    },
    {
      "title": "Find Top News Articles for a Topic",
      "audience": "Investors, Enterprise",
      "dataType": "Posts",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Topic page > News tab",
        "claude": "What news articles are getting the most traction about $AAPL?",
        "claudeCode": "Fetch(id='topic/$aapl/news')",
        "api": "GET /topic/$aapl/news/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=%24aapl",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/$aapl/news/v1",
      "primaryMetric": "Interactions 24h",
      "tags": "news, media-monitoring, press-coverage",
      "order": 28,
      "description": "See which news articles are getting the most social engagement for any topic."
    },
    {
      "title": "View Historical Top Posts by Date Range",
      "audience": "Enterprise, Creators",
      "dataType": "Posts",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Topic page > Posts > Date picker",
        "claude": "What were the top Bitcoin posts on January 20, 2026?",
        "claudeCode": "Topic_Posts(topic='bitcoin', from_date='2026-01-20')",
        "api": "GET /topic/bitcoin/posts/v1?start=1737331200"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=bitcoin",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/bitcoin/posts/v1?start=1737331200",
      "primaryMetric": "Interactions Total",
      "tags": "historical-posts, date-range, retrospective",
      "order": 29,
      "description": "Look up the most engaging posts for any topic on a specific date or date range."
    },
    {
      "title": "Analyze Individual Post Performance",
      "audience": "Creators",
      "dataType": "Post Detail",
      "assetClass": "Any",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Click any post for details",
        "claude": "Analyze this tweet: x.com/user/status/123456789",
        "claudeCode": "Post(id='123456789', network='x')",
        "api": "GET /posts/tweet/123456789/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/posts/tweet/123456789/v1",
      "primaryMetric": "Interactions Total",
      "tags": "post-analytics, individual-post, engagement-breakdown",
      "order": 30,
      "description": "Get detailed metrics for any single post: views, likes, retweets, replies, sentiment."
    },
    {
      "title": "Track How a Post Goes Viral Over Time",
      "audience": "Creators",
      "dataType": "Time Series",
      "assetClass": "Any",
      "workflow": "Content",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Post detail > Engagement timeline",
        "claude": "Show me the engagement timeline for this YouTube video",
        "claudeCode": "Fetch(id='post/youtube-video/{id}/time-series')",
        "api": "GET /posts/youtube-video/{id}/time-series/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/posts/youtube-video/{id}/time-series/v1",
      "primaryMetric": "Interactions",
      "tags": "virality, engagement-curve, post-lifecycle",
      "order": 31,
      "description": "See the interaction time-series for any individual post showing its virality curve."
    },
    {
      "title": "Find Top Posts by Category",
      "audience": "Enterprise, Creators",
      "dataType": "Posts",
      "assetClass": "Any",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Category page > Posts tab",
        "claude": "What are the most viral cryptocurrency posts today?",
        "claudeCode": "Fetch(id='category/cryptocurrencies/posts')",
        "api": "GET /category/cryptocurrencies/posts/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/cryptocurrencies/posts/v1",
      "primaryMetric": "Interactions 24h",
      "tags": "category-posts, viral, content-curation",
      "order": 32,
      "description": "See the most engaging posts across an entire category (e.g., all crypto, all musicians)."
    },
    {
      "title": "Rank Stocks by Galaxy Score",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Stocks",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Stocks > Sort by Galaxy Score",
        "claude": "What are the top 10 stocks by Galaxy Score?",
        "claudeCode": "Stocks(sort='galaxy_score', limit=10)",
        "api": "GET /stocks/list/v2?sort=galaxy_score&limit=10"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=stocks&metric=galaxy_score&sort=galaxy_score",
      "apiUrl": "https://lunarcrush.com/developers/api/public/stocks/list/v1?sort=galaxy_score&limit=10",
      "primaryMetric": "Galaxy Score",
      "tags": "stocks, equity, social-scoring",
      "order": 33,
      "description": "Apply the same social media sentiment scoring to 2,000+ stocks for alpha discovery."
    },
    {
      "title": "Filter Stocks by Sector",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Stocks",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Stocks > Sector filter",
        "claude": "Which technology stocks have the highest sentiment right now?",
        "claudeCode": "Stocks(sort='sentiment', sector='technology', limit=20)",
        "api": "GET /stocks/list/v2?sort=sentiment&filter=technology&limit=20"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=stocks&metric=sentiment&sort=sentiment&filter=technology",
      "apiUrl": "https://lunarcrush.com/developers/api/public/stocks/list/v1?sort=sentiment&filter=technology&limit=20",
      "primaryMetric": "Sentiment",
      "tags": "sector-screen, technology, healthcare, finance",
      "order": 34,
      "description": "Screen stocks by sector (Technology, Healthcare, Financial Services, etc.) with social metrics."
    },
    {
      "title": "Track Bitcoin Spot ETFs Socially",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Stocks",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Stocks > Filter: Bitcoin Spot ETFs",
        "claude": "Show me Bitcoin Spot ETFs ranked by social engagement",
        "claudeCode": "Stocks(sector='bitcoin-spot-etf', sort='interactions')",
        "api": "GET /stocks/list/v2?filter=bitcoin-spot-etf&sort=interactions"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=stocks&metric=interactions&sort=interactions&filter=bitcoin-spot-etf",
      "apiUrl": "https://lunarcrush.com/developers/api/public/stocks/list/v1?filter=bitcoin-spot-etf&sort=interactions",
      "primaryMetric": "Interactions",
      "tags": "etf, bitcoin-etf, institutional",
      "order": 35,
      "description": "Monitor social engagement and sentiment around Bitcoin Spot ETFs specifically."
    },
    {
      "title": "Track Stock Social Metrics Over Time",
      "audience": "Investors",
      "dataType": "Time Series",
      "assetClass": "Stocks",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Stock topic page > Time-series charts",
        "claude": "Show me NVIDIA's social engagement trend over the past 3 months",
        "claudeCode": "Topic_Time_Series(topic='$nvda', interval='3m')",
        "api": "GET /stocks/7056/time-series/v2?interval=3m"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/stocks/7056/time-series/v1?interval=3m",
      "primaryMetric": "Galaxy Score",
      "tags": "stock-trend, time-series, historical-stocks",
      "order": 36,
      "description": "Monitor how social engagement, sentiment, and AltRank change for any stock historically."
    },
    {
      "title": "Find Stocks with Unusual Social Activity",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Stocks",
      "workflow": "Trading",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Stocks > Sort by Engagements",
        "claude": "Which stocks have unusual social activity today?",
        "claudeCode": "Stocks(sort='interactions', limit=20)",
        "api": "GET /stocks/list/v2?sort=interactions&limit=20&desc=1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=stocks&metric=interactions&sort=interactions",
      "apiUrl": "https://lunarcrush.com/developers/api/public/stocks/list/v1?sort=interactions&limit=20&desc=1",
      "primaryMetric": "Interactions",
      "tags": "unusual-activity, spike, stock-signals",
      "order": 37,
      "description": "Identify stocks where social engagement is spiking relative to their norms."
    },
    {
      "title": "Identify Crypto Treasury Stocks",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Stocks",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Stocks > Filter: Bitcoin Treasuries",
        "claude": "Show me Bitcoin Treasury stocks ranked by market cap",
        "claudeCode": "Stocks(sector='bitcoin-treasuries', sort='market_cap')",
        "api": "GET /stocks/list/v2?filter=bitcoin-treasuries&sort=market_cap"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=stocks&metric=market_cap&sort=market_cap&filter=bitcoin-treasuries",
      "apiUrl": "https://lunarcrush.com/developers/api/public/stocks/list/v1?filter=bitcoin-treasuries&sort=market_cap",
      "primaryMetric": "Market Cap",
      "tags": "bitcoin-treasuries, corporate-btc, saylor",
      "order": 38,
      "description": "Track public companies holding Bitcoin on their balance sheet with social metrics."
    },
    {
      "title": "Rank NFT Collections by Galaxy Score",
      "audience": "Investors, Creators",
      "dataType": "Rankings",
      "assetClass": "NFTs",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > NFTs > Sort by Galaxy Score",
        "claude": "What are the top NFT collections by Galaxy Score?",
        "claudeCode": "Fetch(id='list/nfts/galaxy_score/20')",
        "api": "GET /nfts/list/v2?sort=galaxy_score&limit=20"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=nfts&metric=galaxy_score&sort=galaxy_score",
      "apiUrl": "https://lunarcrush.com/developers/api/public/nfts/list/v1?sort=galaxy_score&limit=20",
      "primaryMetric": "Galaxy Score",
      "tags": "nft, collections, nft-ranking",
      "order": 39,
      "description": "Track 460+ NFT collections ranked by combined social and market health."
    },
    {
      "title": "Find NFTs with Rising Social Volume",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "NFTs",
      "workflow": "Trading",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > NFTs > Sort by Social Engagements",
        "claude": "Which NFTs have the highest social engagement today?",
        "claudeCode": "Fetch(id='list/nfts/interactions/20')",
        "api": "GET /nfts/list/v2?sort=interactions&limit=20&desc=1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=nfts&metric=interactions&sort=interactions",
      "apiUrl": "https://lunarcrush.com/developers/api/public/nfts/list/v1?sort=interactions&limit=20&desc=1",
      "primaryMetric": "Interactions",
      "tags": "nft-buzz, social-traction, floor-price-signal",
      "order": 40,
      "description": "Identify NFT collections gaining social traction before floor prices move."
    },
    {
      "title": "Track NFT Collection Metrics Over Time",
      "audience": "Investors",
      "dataType": "Time Series",
      "assetClass": "NFTs",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > NFT collection page > Time-series",
        "claude": "Show me Bored Ape Yacht Club social metrics over the past 6 months",
        "claudeCode": "Fetch(id='nfts/bored-ape-yacht-club/time-series')",
        "api": "GET /nfts/{id}/time-series/v2?interval=6m"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/nfts/{id}/time-series/v1?interval=6m",
      "primaryMetric": "Galaxy Score",
      "tags": "nft-trend, historical-nft, collection-tracking",
      "order": 41,
      "description": "Monitor historical floor price, social engagement, and Galaxy Score for any NFT collection."
    },
    {
      "title": "Benchmark Brand Social Performance",
      "audience": "Enterprise",
      "dataType": "Topic Detail",
      "assetClass": "Brands",
      "workflow": "Marketing",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Search brand > Compare category rankings",
        "claude": "How is Apple trending on social media compared to Google?",
        "claudeCode": "Topic(topic='apple inc') + Topic(topic='google')",
        "api": "GET /topic/apple inc/v1\n GET /topic/google/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=apple%20inc",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/apple%20inc/v1",
      "primaryMetric": "TopicRank",
      "tags": "brand-monitoring, competitive-intel, benchmarking",
      "order": 42,
      "description": "Compare your brand's social engagement, sentiment, and trending rank against competitors."
    },
    {
      "title": "Monitor Technology Brand Rankings",
      "audience": "Enterprise",
      "dataType": "Rankings",
      "assetClass": "Brands",
      "workflow": "Marketing",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Technology Brands",
        "claude": "Show me the top technology brands by social engagement",
        "claudeCode": "List(category='technology-brands', sort='interactions')",
        "api": "GET /category/technology-brands/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=technology-brands",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/technology-brands/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "tech-brands, brand-rankings, competitive-landscape",
      "order": 43,
      "description": "Track which technology companies dominate social conversation."
    },
    {
      "title": "Track Brand Sentiment Over Time",
      "audience": "Enterprise",
      "dataType": "Time Series",
      "assetClass": "Brands",
      "workflow": "Marketing",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Brand topic page > Sentiment trend",
        "claude": "How has sentiment around Tesla changed over the past quarter?",
        "claudeCode": "Topic_Time_Series(topic='tesla', interval='3m', metrics=['sentiment'])",
        "api": "GET /topic/tesla/time-series/v2?bucket=day&interval=3m"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=tesla",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/tesla/time-series/v1?bucket=day&interval=3m",
      "primaryMetric": "Sentiment",
      "tags": "brand-sentiment, reputation, trend-monitoring",
      "order": 44,
      "description": "Monitor how sentiment about your brand or a competitor changes across weeks and months."
    },
    {
      "title": "Find Top News Coverage for Your Brand",
      "audience": "Enterprise",
      "dataType": "Posts",
      "assetClass": "Brands",
      "workflow": "Marketing",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Brand topic > News tab",
        "claude": "What news articles about Microsoft are getting the most engagement?",
        "claudeCode": "Fetch(id='topic/microsoft/news')",
        "api": "GET /topic/microsoft/news/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=microsoft",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/microsoft/news/v1",
      "primaryMetric": "Interactions 24h",
      "tags": "press-monitoring, news-coverage, media-tracking",
      "order": 45,
      "description": "See which news articles about your brand are getting the most social traction."
    },
    {
      "title": "Get AI Summary of Any Topic",
      "audience": "Investors, Builders, Creators, Enterprise",
      "dataType": "AI Summary",
      "assetClass": "Any",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Topic page > What's Up section",
        "claude": "What's happening with Bitcoin today?",
        "claudeCode": "Fetch(id='topic/bitcoin/whatsup')",
        "api": "GET /topic/bitcoin/whatsup/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=bitcoin",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/bitcoin/whatsup/v1",
      "primaryMetric": "N/A",
      "tags": "ai-summary, whats-up, quick-briefing, narrative",
      "order": 46,
      "description": "Instantly get a plain-language summary of the hottest news and social posts for any topic."
    },
    {
      "title": "AI Briefing on Emerging Narratives",
      "audience": "Investors",
      "dataType": "AI Summary",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Search emerging token > What's Up",
        "claude": "Give me a quick summary of what's driving social buzz around LayerZero",
        "claudeCode": "Fetch(id='topic/layerzero/whatsup')",
        "api": "GET /topic/layerzero/whatsup/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=layerzero",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/layerzero/whatsup/v1",
      "primaryMetric": "N/A",
      "tags": "narrative, emerging, ai-briefing, quick-research",
      "order": 47,
      "description": "Use AI summaries to quickly understand what's driving social conversation for emerging tokens."
    },
    {
      "title": "Compare Social vs Market Dominance",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Compare Social Dominance vs Market Dominance columns",
        "claude": "Which crypto assets have the highest social dominance relative to their market cap?",
        "claudeCode": "Cryptocurrencies(sort='social_dominance') > compare social_dominance vs market_dominance",
        "api": "GET /coins/list/v2?sort=social_dominance&limit=50&desc=1"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=social_dominance&sort=social_dominance",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=social_dominance&limit=50&desc=1",
      "primaryMetric": "Social Dominance",
      "tags": "divergence, social-vs-market, alpha-signal",
      "order": 48,
      "description": "Spot divergences between how much conversation an asset commands vs its market cap share."
    },
    {
      "title": "Identify Sector Rotation in Crypto",
      "audience": "Investors",
      "dataType": "Time Series",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "lunarcrush.com > Compare sector filter views over time",
        "claude": "Compare social engagement across DeFi, AI, and Gaming sectors",
        "claudeCode": "Cryptocurrencies(sector='ai') + Cryptocurrencies(sector='defi') + Cryptocurrencies(sector='gaming')",
        "api": "GET /coins/list/v2?filter=ai\n ?filter=defi\n ?filter=gaming"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?filter=ai",
      "primaryMetric": "Interactions",
      "tags": "sector-rotation, capital-flows, macro-crypto",
      "order": 49,
      "description": "Track how social and market activity shifts between sectors over time."
    },
    {
      "title": "Build Automated Trading Signals",
      "audience": "Builders",
      "dataType": "Time Series",
      "assetClass": "Crypto, Stocks",
      "workflow": "Automation",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "lunarcrush.com > Searches feature to save custom filters",
        "claude": "Show me coins where Galaxy Score™ increased by 20+ points in 24h",
        "claudeCode": "Cryptocurrencies() > compare galaxy_score vs galaxy_score_previous",
        "api": "GET /coins/list/v1 > delta(galaxy_score, galaxy_score_previous)"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1",
      "primaryMetric": "Galaxy Score™",
      "tags": "automation, trading-bot, signals, alerting",
      "order": 50,
      "description": "Use time-series social data to build custom alert systems that trigger on Galaxy Score™ changes, sentiment shifts, or engagement spikes."
    },
    {
      "title": "Monitor Galaxy Score + AltRank Shifts",
      "audience": "Investors, Builders",
      "dataType": "Rankings",
      "assetClass": "Crypto, Stocks",
      "workflow": "Trading",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "lunarcrush.com > Compare current vs previous columns for Galaxy Score and AltRank",
        "claude": "Which coins had the biggest Galaxy Score improvement in the last 24 hours?",
        "claudeCode": "Cryptocurrencies() > compare galaxy_score vs galaxy_score_previous, alt_rank vs alt_rank_previous",
        "api": "GET /coins/list/v2 > fields: galaxy_score, galaxy_score_previous, alt_rank, alt_rank_previous"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1",
      "primaryMetric": "Galaxy Score",
      "tags": "score-change, momentum, signal-detection",
      "order": 51,
      "description": "Detect when an asset's Galaxy Score or AltRank changes dramatically (improving or deteriorating)."
    },
    {
      "title": "Track Social Dominance Trends Over Time",
      "audience": "Investors, Enterprise",
      "dataType": "Time Series",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Topic page > Social Dominance chart",
        "claude": "How has Bitcoin's social dominance changed over the past year?",
        "claudeCode": "Topic_Time_Series(topic='bitcoin', interval='1y', metrics=['social_dominance'])",
        "api": "GET /coins/1/time-series/v2?interval=1y&bucket=day"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/1/time-series/v1?interval=1y&bucket=day",
      "primaryMetric": "Social Dominance",
      "tags": "dominance-trend, attention-shift, historical",
      "order": 52,
      "description": "Monitor how an asset's share of all social conversation changes historically."
    },
    {
      "title": "Research Coin Project Fundamentals",
      "audience": "Investors, Builders",
      "dataType": "Metadata",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Coin page > Project info section",
        "claude": "Show me Ethereum's project links, GitHub, and whitepaper",
        "claudeCode": "Fetch(id='coins/2/meta')",
        "api": "GET /coins/2/meta/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/2/meta/v1",
      "primaryMetric": "N/A",
      "tags": "fundamentals, project-info, links, due-diligence",
      "order": 53,
      "description": "Access project metadata including website, GitHub, whitepaper, social links, and descriptions."
    },
    {
      "title": "Monitor Sports League Social Trends",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Select sports league",
        "claude": "Which NFL teams are trending the most on social media?",
        "claudeCode": "List(category='nfl', sort='topic_rank', limit=20)",
        "api": "GET /category/nfl/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/nfl/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "sports, nfl, nba, nhl, mlb, premier-league",
      "order": 54,
      "description": "Track social engagement around NFL, NBA, NHL, MLB, Premier League, and more."
    },
    {
      "title": "Track Celebrity Social Engagement",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Entertainment",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Celebrities",
        "claude": "Who are the most talked-about celebrities on social media today?",
        "claudeCode": "List(category='celebrities', sort='interactions', limit=20)",
        "api": "GET /category/celebrities/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=celebrities",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/celebrities/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "celebrities, entertainment, pop-culture",
      "order": 55,
      "description": "Monitor which celebrities are driving the most social conversation globally."
    },
    {
      "title": "Monitor Exchange Token Social Activity",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: Exchange Tokens",
        "claude": "Which exchange tokens have the highest social engagement?",
        "claudeCode": "Cryptocurrencies(sort='interactions', sector='exchange-tokens')",
        "api": "GET /coins/list/v2?sort=interactions&filter=exchange-tokens"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=interactions&sort=interactions&filter=exchange-tokens",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=interactions&filter=exchange-tokens",
      "primaryMetric": "Interactions",
      "tags": "exchange-tokens, cex-health, bnb, exchange",
      "order": 56,
      "description": "Track social metrics for exchange tokens (BNB, CRO, etc.) as proxy for exchange health."
    },
    {
      "title": "Track DePIN Token Social Metrics",
      "audience": "Investors, Builders",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: DePIN",
        "claude": "What are the top DePIN tokens by Galaxy Score?",
        "claudeCode": "Cryptocurrencies(sort='galaxy_score', sector='depin')",
        "api": "GET /coins/list/v2?sort=galaxy_score&filter=depin"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score&filter=depin",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score&filter=depin",
      "primaryMetric": "Galaxy Score",
      "tags": "depin, infrastructure, iot, physical-networks",
      "order": 57,
      "description": "Monitor the Decentralized Physical Infrastructure sector by social and market data."
    },
    {
      "title": "Integrate Social Data into Dashboards",
      "audience": "Builders, Enterprise",
      "dataType": "API Integration",
      "assetClass": "Any",
      "workflow": "Automation",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "N/A (API-only workflow)",
        "claude": "N/A (developer workflow)",
        "claudeCode": "Configure MCP server URL in Claude or custom LLM integration",
        "api": "All endpoints via /api4/public/* with Bearer token auth"
      },
      "apiUrl": "https://lunarcrush.com/developers/api/endpoints",
      "primaryMetric": "All Metrics",
      "tags": "integration, dashboard, bi-tools, automation, developer",
      "order": 58,
      "description": "Pull real-time social metrics into custom dashboards, BI tools, or internal platforms."
    },
    {
      "title": "Use LunarCrush in Claude Code CLI",
      "audience": "Builders",
      "dataType": "API Integration",
      "assetClass": "Any",
      "workflow": "Automation",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "N/A (CLI workflow)",
        "claude": "N/A (developer workflow)",
        "claudeCode": "Add MCP server config: {url: 'https://mcp.lunarcrush.com/sse', name: 'lunarcrush-mcp'}",
        "api": "MCP server at https://mcp.lunarcrush.com/sse"
      },
      "apiUrl": "https://lunarcrush.com/products/lunarcrush-mcpserver",
      "primaryMetric": "All Metrics",
      "tags": "claude-code, cli, mcp, agentic, developer",
      "order": 59,
      "description": "Access all LunarCrush data through Claude Code command line for agentic developer workflows."
    },
    {
      "title": "Build LLM-Powered Research Agents",
      "audience": "Builders, Enterprise",
      "dataType": "API Integration",
      "assetClass": "Any",
      "workflow": "Automation",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "N/A (developer workflow)",
        "claude": "Connect your LLM to the LunarCrush MCP server for real-time social context",
        "claudeCode": "Connect MCP server URL + API key to any compatible LLM client",
        "api": "MCP server"
      },
      "apiUrl": "REST API for custom agent architectures",
      "primaryMetric": "All Metrics",
      "tags": "agents, autonomous, llm-integration, research-automation",
      "order": 60,
      "description": "Create autonomous agents that combine LunarCrush social data with other data sources for research."
    },
    {
      "title": "Track Top Technology Brands by Social Buzz",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Technology",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Technology Brands",
        "claude": "Which technology brands are trending the most on social media right now?",
        "claudeCode": "List(category='technology-brands', sort='interactions', limit=20)",
        "api": "GET /category/technology-brands/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=technology-brands",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/technology-brands/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "tech-brands, apple, google, microsoft, samsung, brand-ranking",
      "order": 61,
      "description": "Rank technology companies (Apple, Google, Microsoft, Samsung, etc.) by social engagement, sentiment, and trending rank."
    },
    {
      "title": "Monitor Sentiment Around a Tech Product Launch",
      "audience": "Enterprise",
      "dataType": "Time Series",
      "assetClass": "Technology",
      "workflow": "Marketing",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Search product/brand > Sentiment trend chart",
        "claude": "How did sentiment around Apple change during their latest product launch?",
        "claudeCode": "Topic_Time_Series(topic='apple inc', interval='1m', metrics=['sentiment','interactions'])",
        "api": "GET /topic/apple inc/time-series/v2?bucket=day&interval=1m"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=apple%20inc",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/apple inc/time-series/v1?bucket=day&interval=1m",
      "primaryMetric": "Sentiment",
      "tags": "product-launch, tech, sentiment-shift, event-tracking",
      "order": 62,
      "description": "Track how social sentiment shifts before, during, and after a major tech product launch."
    },
    {
      "title": "Compare Social Engagement Across Tech Rivals",
      "audience": "Enterprise",
      "dataType": "Topic Detail",
      "assetClass": "Technology",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Search each brand > Compare metrics",
        "claude": "Compare social engagement and sentiment between Microsoft and Google this week",
        "claudeCode": "Topic(topic='microsoft') + Topic(topic='google')",
        "api": "GET /topic/microsoft/v1\n GET /topic/google/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=microsoft",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/microsoft/v1\n https://lunarcrush.com/developers/api/public/topic/google/v1",
      "primaryMetric": "Interactions",
      "tags": "competitive-analysis, tech-rivalry, comparison, benchmarking",
      "order": 63,
      "description": "Side-by-side comparison of social metrics between competing tech brands."
    },
    {
      "title": "Identify Top Social Creators in Tech",
      "audience": "Enterprise, Creators",
      "dataType": "Creator Rankings",
      "assetClass": "Technology",
      "workflow": "Marketing",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Technology Brands category > Creators section",
        "claude": "Who are the top creators driving tech conversations on social media?",
        "claudeCode": "Fetch(id='category/technology-brands/creators')",
        "api": "GET /category/technology-brands/creators/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/technology-brands/creators/v1",
      "primaryMetric": "Creator Rank",
      "tags": "tech-influencers, kol, creator-discovery, technology",
      "order": 64,
      "description": "Find the influencers and creators driving the most engagement in technology conversations."
    },
    {
      "title": "Track Social Networks Platform Trends",
      "audience": "Enterprise, Builders",
      "dataType": "Rankings",
      "assetClass": "Technology",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Social Networks",
        "claude": "Which social media platforms are trending the most right now?",
        "claudeCode": "List(category='social-networks', sort='topic_rank', limit=20)",
        "api": "GET /category/social-networks/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=social-networks",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/social-networks/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "social-platforms, tiktok, instagram, youtube, x, snapchat",
      "order": 65,
      "description": "Monitor social engagement trends around platforms like TikTok, Instagram, YouTube, X, Snapchat."
    },
    {
      "title": "Monitor Gaming Industry Social Trends",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Technology",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Gaming",
        "claude": "What games and gaming brands are trending the most on social media today?",
        "claudeCode": "List(category='gaming', sort='interactions', limit=20)",
        "api": "GET /category/gaming/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=gaming",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/gaming/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "gaming, esports, consoles, game-trends, entertainment",
      "order": 66,
      "description": "Track which games, consoles, and gaming brands are trending across social media."
    },
    {
      "title": "Track Product Category Social Trends",
      "audience": "Enterprise",
      "dataType": "Rankings",
      "assetClass": "Technology",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Products",
        "claude": "Which consumer products are trending the most on social media?",
        "claudeCode": "List(category='products', sort='interactions', limit=20)",
        "api": "GET /category/products/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=products",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/products/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "products, consumer-tech, gadgets, wearables",
      "order": 67,
      "description": "Monitor social buzz and sentiment around consumer products (phones, laptops, wearables, etc.)."
    },
    {
      "title": "Track NFL Team Social Rankings",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > NFL",
        "claude": "Which NFL teams are trending the most on social media right now?",
        "claudeCode": "List(category='nfl', sort='topic_rank', limit=32)",
        "api": "GET /category/nfl/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=nfl",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/nfl/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "nfl, football, american-football, sports-ranking",
      "order": 68,
      "description": "See which NFL teams dominate social conversation during the season, playoffs, and offseason."
    },
    {
      "title": "Monitor NBA Player and Team Buzz",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > NBA",
        "claude": "Which NBA topics are trending the most on social media today?",
        "claudeCode": "List(category='nba', sort='interactions', limit=20)",
        "api": "GET /category/nba/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=nba",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/nba/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "nba, basketball, sports-engagement",
      "order": 69,
      "description": "Track which NBA teams and players are generating the most social engagement."
    },
    {
      "title": "Track Premier League Social Trends",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Premier League",
        "claude": "Which Premier League clubs are trending the most on social media?",
        "claudeCode": "List(category='premier-league', sort='topic_rank', limit=20)",
        "api": "GET /category/premier-league/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=premier-league",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/premier-league/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "premier-league, epl, soccer, football, uk",
      "order": 70,
      "description": "Monitor social buzz around Premier League clubs, players, and matchdays."
    },
    {
      "title": "Monitor Champions League Social Engagement",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Champions League",
        "claude": "Which Champions League topics are generating the most social engagement?",
        "claudeCode": "List(category='champions-league', sort='interactions', limit=20)",
        "api": "GET /category/champions-league/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=champions-league",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/champions-league/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "champions-league, ucl, european-football, soccer",
      "order": 71,
      "description": "Track social buzz around Champions League matches, clubs, and storylines."
    },
    {
      "title": "Track La Liga Social Rankings",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > La Liga",
        "claude": "Which La Liga topics are trending the most right now?",
        "claudeCode": "List(category='la-liga', sort='topic_rank', limit=20)",
        "api": "GET /category/la-liga/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=la-liga",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/la-liga/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "la-liga, spanish-football, soccer, real-madrid, barcelona",
      "order": 72,
      "description": "Monitor which La Liga clubs and players are trending on social media."
    },
    {
      "title": "Track Bundesliga Social Activity",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Bundesliga",
        "claude": "Which Bundesliga clubs are trending on social media?",
        "claudeCode": "List(category='bundesliga', sort='topic_rank', limit=20)",
        "api": "GET /category/bundesliga/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=bundesliga",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/bundesliga/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "bundesliga, german-football, soccer, bayern",
      "order": 73,
      "description": "Monitor German football club social buzz and fan engagement."
    },
    {
      "title": "Monitor Formula 1 Social Trends",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Formula 1",
        "claude": "Which Formula 1 drivers and teams are trending the most right now?",
        "claudeCode": "List(category='formula-1', sort='interactions', limit=20)",
        "api": "GET /category/formula-1/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=formula-1",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/formula-1/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "f1, formula-1, motorsport, racing, verstappen",
      "order": 74,
      "description": "Track which F1 drivers, teams, and race events are generating the most social buzz."
    },
    {
      "title": "Track UFC Fighter and Event Social Buzz",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > UFC",
        "claude": "Which UFC fighters and events are trending on social media?",
        "claudeCode": "List(category='ufc', sort='interactions', limit=20)",
        "api": "GET /category/ufc/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=ufc",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/ufc/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "ufc, mma, combat-sports, fighting",
      "order": 75,
      "description": "Monitor social engagement around UFC fighters, events, and fight week narratives."
    },
    {
      "title": "Monitor MLB Social Activity",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > MLB",
        "claude": "Which MLB teams and players are trending the most right now?",
        "claudeCode": "List(category='mlb', sort='topic_rank', limit=20)",
        "api": "GET /category/mlb/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=mlb",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/mlb/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "mlb, baseball, sports",
      "order": 76,
      "description": "Track which MLB teams, players, and storylines are trending during the season."
    },
    {
      "title": "Track NHL Social Engagement",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > NHL",
        "claude": "Which NHL teams are generating the most social engagement?",
        "claudeCode": "List(category='nhl', sort='interactions', limit=20)",
        "api": "GET /category/nhl/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=nhl",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/nhl/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "nhl, hockey, ice-hockey, sports",
      "order": 77,
      "description": "Monitor hockey social buzz around NHL teams, players, and playoff races."
    },
    {
      "title": "Monitor PGA Golfer Social Rankings",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > PGA Golfers",
        "claude": "Which PGA golfers are trending the most on social media?",
        "claudeCode": "List(category='pga-golfers', sort='topic_rank', limit=20)",
        "api": "GET /category/pga-golfers/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=pga-golfers",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/pga-golfers/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "pga, golf, golfers, sports",
      "order": 78,
      "description": "Track which pro golfers are trending and generating the most social buzz."
    },
    {
      "title": "Track NASCAR Social Trends",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > NASCAR",
        "claude": "Which NASCAR drivers are trending the most on social media?",
        "claudeCode": "List(category='nascar', sort='interactions', limit=20)",
        "api": "GET /category/nascar/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=nascar",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/nascar/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "nascar, racing, motorsport, stock-car",
      "order": 79,
      "description": "Monitor driver and race social engagement across NASCAR events."
    },
    {
      "title": "Track NCAA Football Social Buzz",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > NCAA Football",
        "claude": "Which NCAA football programs are trending the most right now?",
        "claudeCode": "List(category='ncaa-football', sort='topic_rank', limit=20)",
        "api": "GET /category/ncaa-football/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=ncaa-football",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/ncaa-football/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "ncaa, college-football, cfb, recruiting",
      "order": 80,
      "description": "Monitor college football teams, conferences, and recruiting narratives on social media."
    },
    {
      "title": "Track NCAA Basketball Social Engagement",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > NCAA Basketball",
        "claude": "Which NCAA basketball programs are generating the most social buzz?",
        "claudeCode": "List(category='ncaa-basketball', sort='interactions', limit=20)",
        "api": "GET /category/ncaa-basketball/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=ncaa-basketball",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/ncaa-basketball/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "ncaa, college-basketball, march-madness, cbb",
      "order": 81,
      "description": "Monitor March Madness, conference play, and college basketball social trends."
    },
    {
      "title": "Track MLS Social Trends",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > MLS",
        "claude": "Which MLS teams are trending the most on social media?",
        "claudeCode": "List(category='mls', sort='topic_rank', limit=20)",
        "api": "GET /category/mls/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=mls",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/mls/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "mls, us-soccer, soccer, american-soccer",
      "order": 82,
      "description": "Monitor Major League Soccer team and player social engagement."
    },
    {
      "title": "Track Liga MX Social Rankings",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Liga MX",
        "claude": "Which Liga MX clubs are trending on social media?",
        "claudeCode": "List(category='liga-mx', sort='topic_rank', limit=20)",
        "api": "GET /category/liga-mx/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=liga-mx",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/liga-mx/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "liga-mx, mexican-football, soccer, mexico",
      "order": 83,
      "description": "Monitor Mexican football league social buzz and fan engagement."
    },
    {
      "title": "Compare Social Buzz Across Sports Leagues",
      "audience": "Enterprise",
      "dataType": "Rankings",
      "assetClass": "Sports",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Categories overview > Compare sports categories",
        "claude": "Which sports leagues have the most social engagement right now?",
        "claudeCode": "Fetch(id='categories/list') > filter sports categories",
        "api": "GET /categories/list/v1 > filter by sports"
      },
      "discoverUrl": "https://lunarcrush.com/home",
      "apiUrl": "https://lunarcrush.com/developers/api/public/categories/list/v1",
      "primaryMetric": "Interactions",
      "tags": "cross-sport, league-comparison, attention-mapping, macro-sports",
      "order": 84,
      "description": "Rank all sports categories against each other to see where attention is flowing."
    },
    {
      "title": "Track Sports Event Sentiment Spikes",
      "audience": "Enterprise",
      "dataType": "Time Series",
      "assetClass": "Sports",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Search event topic > Time-series charts",
        "claude": "How did social sentiment change during the Super Bowl?",
        "claudeCode": "Topic_Time_Series(topic='super bowl', interval='1w', metrics=['sentiment','interactions'])",
        "api": "GET /topic/super bowl/time-series/v2?bucket=hour&interval=1w"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=super%20bowl",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/super bowl/time-series/v1?bucket=hour&interval=1w",
      "primaryMetric": "Sentiment",
      "tags": "event-tracking, super-bowl, world-cup, sentiment-spike",
      "order": 85,
      "description": "Monitor how sentiment and engagement shift around major sporting events (Super Bowl, World Cup, etc.)."
    },
    {
      "title": "Track Finance Category Social Trends",
      "audience": "Investors, Enterprise",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Finance",
        "claude": "What finance topics are trending the most on social media?",
        "claudeCode": "List(category='finance', sort='topic_rank', limit=20)",
        "api": "GET /category/finance/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=finance",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/finance/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "finance, banking, fintech, investing, macro",
      "order": 86,
      "description": "Monitor social engagement across the broader finance category (banks, fintech, investing topics)."
    },
    {
      "title": "Monitor Currency Pair Social Sentiment",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Currencies",
        "claude": "Which currencies are generating the most social conversation right now?",
        "claudeCode": "List(category='currencies', sort='interactions', limit=20)",
        "api": "GET /category/currencies/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=currencies",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/currencies/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "forex, currencies, usd, eur, gbp, jpy, fiat",
      "order": 87,
      "description": "Track social sentiment around major fiat currencies (USD, EUR, GBP, JPY, etc.)."
    },
    {
      "title": "Track VC Firm Social Activity",
      "audience": "Enterprise, Builders",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > VC Firms",
        "claude": "Which VC firms are trending the most on social media?",
        "claudeCode": "List(category='vc-firms', sort='topic_rank', limit=20)",
        "api": "GET /category/vc-firms/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=vc-firms",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/vc-firms/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "vc, venture-capital, fundraising, startups",
      "order": 88,
      "description": "Monitor which venture capital firms are trending in social conversation."
    },
    {
      "title": "Track Financial Services Brand Rankings",
      "audience": "Enterprise",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Financial Services",
        "claude": "Which financial services brands are trending the most on social media?",
        "claudeCode": "List(category='financial-services', sort='interactions', limit=20)",
        "api": "GET /category/financial-services/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=financial-services",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/financial-services/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "banks, financial-services, jpmorgan, goldman, institutional",
      "order": 89,
      "description": "Monitor social engagement around major financial services brands (Goldman Sachs, JPMorgan, etc.)."
    },
    {
      "title": "Monitor Crypto Exchange Social Health",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Exchanges",
        "claude": "Which crypto exchanges are trending the most on social media?",
        "claudeCode": "List(category='exchanges', sort='interactions', limit=20)",
        "api": "GET /category/exchanges/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=exchanges",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/exchanges/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "exchanges, binance, coinbase, kraken, cex",
      "order": 90,
      "description": "Track social metrics for crypto exchanges (Binance, Coinbase, Kraken, etc.) as proxy for trust and activity."
    },
    {
      "title": "Track Ethereum Spot ETFs Socially",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Stocks > Filter: Ethereum Spot ETFs",
        "claude": "Show me Ethereum Spot ETFs ranked by social engagement",
        "claudeCode": "Stocks(sector='ethereum-spot-etf', sort='interactions')",
        "api": "GET /stocks/list/v2?filter=ethereum-spot-etf&sort=interactions"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=stocks&metric=interactions&sort=interactions&filter=ethereum-spot-etf",
      "apiUrl": "https://lunarcrush.com/developers/api/public/stocks/list/v1?filter=ethereum-spot-etf&sort=interactions",
      "primaryMetric": "Interactions",
      "tags": "etf, ethereum-etf, eth-etf, institutional",
      "order": 91,
      "description": "Monitor social engagement around Ethereum Spot ETFs alongside market data."
    },
    {
      "title": "Monitor All Crypto ETF Social Activity",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Stocks > Filter: Crypto ETFs",
        "claude": "Which crypto ETFs have the highest social engagement?",
        "claudeCode": "Stocks(sector='crypto-etfs', sort='interactions')",
        "api": "GET /stocks/list/v2?filter=crypto-etfs&sort=interactions"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=stocks&metric=interactions&sort=interactions&filter=crypto-etfs",
      "apiUrl": "https://lunarcrush.com/developers/api/public/stocks/list/v1?filter=crypto-etfs&sort=interactions",
      "primaryMetric": "Interactions",
      "tags": "crypto-etf, etf, institutional, tradfi",
      "order": 92,
      "description": "Track the full universe of crypto-related ETFs with social media sentiment metrics."
    },
    {
      "title": "Track Bank Stock Social Metrics",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Stocks > Filter: Banks",
        "claude": "Which bank stocks have the most social activity right now?",
        "claudeCode": "Stocks(sector='banks', sort='interactions')",
        "api": "GET /stocks/list/v2?filter=banks&sort=interactions"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=stocks&metric=interactions&sort=interactions&filter=banks",
      "apiUrl": "https://lunarcrush.com/developers/api/public/stocks/list/v1?filter=banks&sort=interactions",
      "primaryMetric": "Interactions",
      "tags": "banks, bank-stocks, financial-sector",
      "order": 93,
      "description": "Monitor social engagement and sentiment around major bank stocks."
    },
    {
      "title": "Monitor Real-World Asset Token Social Trends",
      "audience": "Investors, Builders",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: Real-World Assets",
        "claude": "What are the top real-world asset tokens by Galaxy Score?",
        "claudeCode": "Cryptocurrencies(sort='galaxy_score', sector='real-world-assets')",
        "api": "GET /coins/list/v2?sort=galaxy_score&filter=real-world-assets"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score&filter=real-world-assets",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score&filter=real-world-assets",
      "primaryMetric": "Galaxy Score",
      "tags": "rwa, tokenization, real-world-assets, tradfi-bridge",
      "order": 94,
      "description": "Track the RWA crypto sector (tokenized treasuries, real estate, private credit)."
    },
    {
      "title": "Track Lending/Borrowing Protocol Social Activity",
      "audience": "Investors, Builders",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: Lending/Borrowing",
        "claude": "Which DeFi lending protocols have the most social buzz?",
        "claudeCode": "Cryptocurrencies(sort='interactions', sector='lending-borrowing')",
        "api": "GET /coins/list/v2?sort=interactions&filter=lending-borrowing"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=interactions&sort=interactions&filter=lending-borrowing",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=interactions&filter=lending-borrowing",
      "primaryMetric": "Interactions",
      "tags": "lending, borrowing, defi, aave, compound",
      "order": 95,
      "description": "Monitor DeFi lending protocols by social engagement and sentiment."
    },
    {
      "title": "Track Prediction Market Token Social Trends",
      "audience": "Investors",
      "dataType": "Rankings",
      "assetClass": "Finance",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: Prediction Markets",
        "claude": "Which prediction market tokens are trending?",
        "claudeCode": "Cryptocurrencies(sort='galaxy_score', sector='prediction')",
        "api": "GET /coins/list/v2?sort=galaxy_score&filter=prediction"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score&filter=prediction",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score&filter=prediction",
      "primaryMetric": "Galaxy Score",
      "tags": "prediction-markets, polymarket, betting, forecasting",
      "order": 96,
      "description": "Monitor social engagement around prediction market platforms (Polymarket, Kalshi adjacent tokens)."
    },
    {
      "title": "Track Luxury Brand Social Rankings",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Luxury",
      "workflow": "Marketing",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Luxury Brands",
        "claude": "Which luxury brands are trending the most on social media right now?",
        "claudeCode": "List(category='luxury-brands', sort='topic_rank', limit=20)",
        "api": "GET /category/luxury-brands/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=luxury-brands",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/luxury-brands/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "luxury, luxury-brands, lvmh, gucci, rolex, hermes",
      "order": 97,
      "description": "Monitor which luxury brands (Louis Vuitton, Gucci, Rolex, Hermes, etc.) dominate social conversation."
    },
    {
      "title": "Monitor Fashion Brand Social Trends",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Luxury",
      "workflow": "Marketing",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Fashion Brands",
        "claude": "Which fashion brands are generating the most social engagement?",
        "claudeCode": "List(category='fashion-brands', sort='interactions', limit=20)",
        "api": "GET /category/fashion-brands/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=fashion-brands",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/fashion-brands/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "fashion, fashion-brands, designer, haute-couture, style",
      "order": 98,
      "description": "Track social engagement across fashion brands and designers."
    },
    {
      "title": "Compare Luxury Brand Sentiment",
      "audience": "Enterprise",
      "dataType": "Topic Detail",
      "assetClass": "Luxury",
      "workflow": "Marketing",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Search each brand > Compare sentiment",
        "claude": "Compare social sentiment between Louis Vuitton and Gucci",
        "claudeCode": "Topic(topic='louis vuitton') + Topic(topic='gucci')",
        "api": "GET /topic/louis vuitton/v1\n GET /topic/gucci/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=louis%20vuitton",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/louis%20vuitton/v1",
      "primaryMetric": "Sentiment",
      "tags": "luxury-comparison, brand-sentiment, competitive-intel",
      "order": 99,
      "description": "Benchmark sentiment scores between competing luxury brands."
    },
    {
      "title": "Track Luxury Brand Social Engagement Over Time",
      "audience": "Enterprise",
      "dataType": "Time Series",
      "assetClass": "Luxury",
      "workflow": "Marketing",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com > Luxury brand topic > Time-series charts",
        "claude": "How has Rolex's social engagement changed over the past 3 months?",
        "claudeCode": "Topic_Time_Series(topic='rolex', interval='3m', metrics=['interactions','sentiment'])",
        "api": "GET /topic/rolex/time-series/v2?bucket=day&interval=3m"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=rolex",
      "apiUrl": "https://lunarcrush.com/developers/api/public/topic/rolex/time-series/v1?bucket=day&interval=3m",
      "primaryMetric": "Interactions",
      "tags": "luxury-trend, brand-tracking, campaign-measurement",
      "order": 100,
      "description": "Monitor how a luxury brand's social presence changes over fashion weeks, launches, and campaigns."
    },
    {
      "title": "Identify Top Luxury Creators and Influencers",
      "audience": "Enterprise, Creators",
      "dataType": "Creator Rankings",
      "assetClass": "Luxury",
      "workflow": "Marketing",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com > Luxury Brands category > Creators section",
        "claude": "Who are the top influencers in luxury brand conversations?",
        "claudeCode": "Fetch(id='category/luxury-brands/creators')",
        "api": "GET /category/luxury-brands/creators/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=luxury-brands",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/luxury-brands/creators/v1",
      "primaryMetric": "Creator Rank",
      "tags": "luxury-influencers, kol, fashion-kol, brand-ambassadors",
      "order": 101,
      "description": "Find the social accounts driving the most engagement in luxury brand conversations."
    },
    {
      "title": "Track Automotive Brand Social Rankings",
      "audience": "Enterprise",
      "dataType": "Rankings",
      "assetClass": "Luxury",
      "workflow": "Marketing",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Automotive Brands",
        "claude": "Which automotive brands are trending the most on social media?",
        "claudeCode": "List(category='automotive-brands', sort='topic_rank', limit=20)",
        "api": "GET /category/automotive-brands/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=automotive-brands",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/automotive-brands/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "automotive, cars, tesla, bmw, porsche, ferrari, luxury-auto",
      "order": 102,
      "description": "Monitor which auto brands (Tesla, BMW, Porsche, Ferrari, etc.) are trending in social conversation."
    },
    {
      "title": "Track Country-Level Social Trends",
      "audience": "Enterprise",
      "dataType": "Rankings",
      "assetClass": "Geopolitics",
      "workflow": "Research",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Countries",
        "claude": "Which countries are trending the most on social media right now?",
        "claudeCode": "List(category='countries', sort='topic_rank', limit=20)",
        "api": "GET /category/countries/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=countries",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/countries/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "countries, geopolitics, global-trends, international",
      "order": 103,
      "description": "See which countries are trending in global social conversation."
    },
    {
      "title": "Track Travel Destination Social Trends",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Travel",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Travel Destinations",
        "claude": "Which travel destinations are trending the most on social media?",
        "claudeCode": "List(category='travel-destinations', sort='interactions', limit=20)",
        "api": "GET /category/travel-destinations/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=travel-destinations",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/travel-destinations/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "travel, destinations, tourism, vacation, hospitality",
      "order": 104,
      "description": "Monitor which travel destinations are generating the most social buzz."
    },
    {
      "title": "Track Major Event Social Engagement",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Events",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Events",
        "claude": "Which major events are generating the most social engagement?",
        "claudeCode": "List(category='events', sort='interactions', limit=20)",
        "api": "GET /category/events/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=events",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/events/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "events, conferences, awards, summits, cultural-events",
      "order": 105,
      "description": "Monitor social engagement around major global events (awards shows, conferences, summits)."
    },
    {
      "title": "Track Musician Social Rankings",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Entertainment",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Musicians",
        "claude": "Which musicians are trending the most on social media today?",
        "claudeCode": "List(category='musicians', sort='topic_rank', limit=20)",
        "api": "GET /category/musicians/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=musicians",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/musicians/topics/v1",
      "primaryMetric": "TopicRank",
      "tags": "musicians, music, artists, entertainment, trending-music",
      "order": 106,
      "description": "Monitor which musicians, bands, and artists are trending the most on social media."
    },
    {
      "title": "Track Celebrity Social Rankings",
      "audience": "Enterprise, Creators",
      "dataType": "Rankings",
      "assetClass": "Entertainment",
      "workflow": "Content",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "lunarcrush.com/home > Categories > Celebrities",
        "claude": "Which celebrities are generating the most social buzz right now?",
        "claudeCode": "List(category='celebrities', sort='interactions', limit=20)",
        "api": "GET /category/celebrities/topics/v1"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=celebrities",
      "apiUrl": "https://lunarcrush.com/developers/api/public/category/celebrities/topics/v1",
      "primaryMetric": "Interactions",
      "tags": "celebrities, pop-culture, entertainment, fame",
      "order": 107,
      "description": "Monitor which celebrities are driving the most social conversation globally."
    },
    {
      "title": "Track Liquid Staking Token Social Activity",
      "audience": "Investors, Builders",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: Liquid Staking Derivatives",
        "claude": "Which liquid staking tokens have the best Galaxy Score?",
        "claudeCode": "Cryptocurrencies(sort='galaxy_score', sector='liquid-staking-tokens')",
        "api": "GET /coins/list/v2?sort=galaxy_score&filter=liquid-staking-tokens"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score&filter=liquid-staking-tokens",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score&filter=liquid-staking-tokens",
      "primaryMetric": "Galaxy Score",
      "tags": "lst, liquid-staking, steth, reth, staking",
      "order": 108,
      "description": "Monitor social buzz around LSTs (stETH, rETH, etc.)."
    },
    {
      "title": "Track SocialFi Token Trends",
      "audience": "Investors, Builders, Creators",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: SocialFi",
        "claude": "Which SocialFi tokens are trending the most?",
        "claudeCode": "Cryptocurrencies(sort='galaxy_score', sector='socialfi')",
        "api": "GET /coins/list/v2?sort=galaxy_score&filter=socialfi"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score&filter=socialfi",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score&filter=socialfi",
      "primaryMetric": "Galaxy Score",
      "tags": "socialfi, social-tokens, farcaster, social-web3",
      "order": 109,
      "description": "Monitor tokens in the SocialFi sector (friend.tech, Farcaster ecosystem, etc.)."
    },
    {
      "title": "Track DeFAI Token Social Metrics",
      "audience": "Investors, Builders",
      "dataType": "Rankings",
      "assetClass": "Crypto",
      "workflow": "Research",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "lunarcrush.com/home > Cryptocurrencies > Filter: DeFAI",
        "claude": "What are the top DeFAI tokens by social engagement?",
        "claudeCode": "Cryptocurrencies(sort='interactions', sector='defai')",
        "api": "GET /coins/list/v2?sort=interactions&filter=defai"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=interactions&sort=interactions&filter=defai",
      "apiUrl": "https://lunarcrush.com/developers/api/public/coins/list/v1?sort=interactions&filter=defai",
      "primaryMetric": "Interactions",
      "tags": "defai, defi-ai, emerging-sector, ai-finance",
      "order": 110,
      "description": "Monitor the emerging DeFAI (DeFi + AI) sector by social and market data."
    },
    {
      "title": "\nTrack Price-Sentiment Divergence\n",
      "audience": "\nInvestors\n",
      "dataType": "\nTime Series\n",
      "assetClass": "\nCrypto\n",
      "workflow": "\nTrading\n",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "\nlunarcrush.com > Topic page > Overlay sentiment and price charts\n",
        "claude": "\nWhich coins have rising sentiment but flat or falling price right now?\n",
        "claudeCode": "\nTopic_Time_Series(topic='bitcoin', interval='1m', metrics=['sentiment','price'])\n",
        "api": "\nGET /topic/{symbol}/time-series/v2?interval=1m\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=bitcoin",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/topic/bitcoin/time-series/v1?interval=1m\n",
      "primaryMetric": "\nSentiment\n",
      "tags": "\ndivergence, price-sentiment, alpha, early-signal, pre-pump\n",
      "order": 115,
      "description": "Identify assets where social sentiment is improving while price hasn't moved yet -- a classic early-entry signal."
    },
    {
      "title": "\nMonitor Regulatory Narrative Sentiment\n",
      "audience": "\nInvestors, Enterprise\n",
      "dataType": "\nSentiment\n",
      "assetClass": "\nCrypto\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "\nlunarcrush.com > Search 'SEC' or 'regulation' > Sentiment tab\n",
        "claude": "\nHow is the market reacting to SEC crypto news right now?\n",
        "claudeCode": "\nTopic(topic='sec') > sentiment\n",
        "api": "\nGET /topic/sec/v1\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=sec",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/topic/sec/v1\n",
      "primaryMetric": "\nSentiment\n",
      "tags": "\nregulation, macro-risk, sec, cftc, policy, compliance\n",
      "order": 116,
      "description": "Track social sentiment around regulatory topics (SEC, CFTC, legislation) to gauge macro risk."
    },
    {
      "title": "\nIdentify Influencer Pump Patterns\n",
      "audience": "\nInvestors, Enterprise\n",
      "dataType": "\nPosts\n",
      "assetClass": "\nCrypto\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "\nlunarcrush.com > Topic page > Top Posts > Sort by Engagements\n",
        "claude": "\nWhich influencers are driving outsized social engagement for a specific coin right now?\n",
        "claudeCode": "\nTopic_Posts(topic='solana', sort='interactions', limit=50)\n",
        "api": "\nGET /topic/{symbol}/posts/v1?sort=interactions&limit=50\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=bitcoin",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/topic/bitcoin/posts/v1?sort=interactions&limit=50\n",
      "primaryMetric": "\nInteractions\n",
      "tags": "\nkol, influencer, pump-detection, coordinated, manipulation\n",
      "order": 117,
      "description": "Find high-follower accounts posting about an asset to distinguish organic traction from coordinated promotion."
    },
    {
      "title": "\nTrack Pharma and Biotech Brand Social Trends\n",
      "audience": "\nEnterprise, Investors\n",
      "dataType": "\nRankings\n",
      "assetClass": "\nStocks\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "\nlunarcrush.com/home > Categories > Pharmaceuticals\n",
        "claude": "\nWhich pharma and biotech brands are generating the most social buzz right now?\n",
        "claudeCode": "\nList(category='pharmaceuticals', sort='interactions', limit=20)\n",
        "api": "\nGET /category/pharmaceuticals/topics/v1\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=pharmaceuticals",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/category/pharmaceuticals/topics/v1\n",
      "primaryMetric": "\nInteractions\n",
      "tags": "\npharma, biotech, healthcare, drug-approval, brand-monitoring\n",
      "order": 118,
      "description": "Monitor social traction for pharma companies around drug approvals and clinical trial announcements."
    },
    {
      "title": "\nCompare Crypto Exchange Social Health\n",
      "audience": "\nInvestors, Enterprise\n",
      "dataType": "\nSentiment\n",
      "assetClass": "\nCrypto\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "\nlunarcrush.com > Search each exchange > Compare Galaxy Score and sentiment\n",
        "claude": "\nCompare the social health and sentiment of Binance vs Coinbase vs Kraken right now\n",
        "claudeCode": "\nTopic(topic='binance') vs Topic(topic='coinbase') > galaxy_score\n",
        "api": "\nGET /topic/{exchange}/v1 for each exchange\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=binance",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/topic/binance/v1\n",
      "primaryMetric": "\nGalaxy Score\n",
      "tags": "\nexchange, cex, counterparty-risk, binance, coinbase, comparison\n",
      "order": 119,
      "description": "Side-by-side social health comparison for major exchanges -- useful for counterparty risk awareness."
    },
    {
      "title": "\nTrack Macro Event Social Impact\n",
      "audience": "\nInvestors, Enterprise\n",
      "dataType": "\nTime Series\n",
      "assetClass": "\nCrypto, Stocks\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "\nlunarcrush.com > Search 'FOMC' or 'CPI' > Time Series chart\n",
        "claude": "\nHow did social engagement and sentiment shift around the last FOMC meeting?\n",
        "claudeCode": "\nTopic_Time_Series(topic='fomc', interval='1w', metrics=['interactions','sentiment'])\n",
        "api": "\nGET /topic/fomc/time-series/v2?interval=1w\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=fomc",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/topic/fomc/time-series/v1?interval=1w\n",
      "primaryMetric": "\nInteractions\n",
      "tags": "\nmacro, fomc, cpi, event-driven, cross-asset, volatility\n",
      "order": 120,
      "description": "Measure how macro events (FOMC, CPI, earnings season) affect social activity and sentiment across asset classes."
    },
    {
      "title": "\nTrack Media and Entertainment Brand Rankings\n",
      "audience": "\nEnterprise, Creators\n",
      "dataType": "\nRankings\n",
      "assetClass": "\nStocks\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "\nlunarcrush.com/home > Categories > Media\n",
        "claude": "\nWhich media and entertainment companies are trending the most on social right now?\n",
        "claudeCode": "\nList(category='media', sort='galaxy_score', limit=20)\n",
        "api": "\nGET /category/media/topics/v1\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=media",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/category/media/topics/v1\n",
      "primaryMetric": "\nGalaxy Score\n",
      "tags": "\nmedia, entertainment, netflix, disney, streaming, brand\n",
      "order": 121,
      "description": "Monitor Netflix vs Disney vs Warner Bros and other media companies by social buzz and sentiment."
    },
    {
      "title": "\nBuild a Social Sentiment Alert System\n",
      "audience": "\nBuilders, Enterprise\n",
      "dataType": "\nSentiment\n",
      "assetClass": "\nCrypto, Stocks\n",
      "workflow": "\nAutomation\n",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "\nlunarcrush.com > API Docs > Topic endpoint\n",
        "claude": "\nBuild me a script that alerts when Bitcoin sentiment drops below 60 or spikes above 80\n",
        "claudeCode": "\nTopic(topic='bitcoin') > sentiment -- poll and compare to threshold\n",
        "api": "\nGET /topic/{symbol}/v1 > sentiment polled on interval\n"
      },
      "discoverUrl": "\nhttps://lunarcrush.com/developers\n",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/topic/bitcoin/v1\n",
      "primaryMetric": "\nSentiment\n",
      "tags": "\nalerting, automation, webhook, threshold, real-time, devops\n",
      "order": 122,
      "description": "Use the LunarCrush API to build threshold-based sentiment alerts for any asset -- push to Slack, email, or webhook."
    },
    {
      "title": "\nTrack Stablecoin Social Stability\n",
      "audience": "\nInvestors, Enterprise\n",
      "dataType": "\nRankings\n",
      "assetClass": "\nCrypto\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "\nlunarcrush.com/home > Cryptocurrencies > Filter: Stablecoins\n",
        "claude": "\nAre any stablecoins seeing unusual social activity or negative sentiment right now?\n",
        "claudeCode": "\nCryptocurrencies(sort='interactions', sector='stablecoins')\n",
        "api": "\nGET /coins/list/v2?sort=galaxy_score&filter=stablecoins\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?metric=galaxy_score&sort=galaxy_score&filter=stablecoins%0A",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/coins/list/v1?sort=galaxy_score&filter=stablecoins\n",
      "primaryMetric": "\nInteractions\n",
      "tags": "\nstablecoin, depeg, usdt, usdc, dai, risk-monitoring\n",
      "order": 123,
      "description": "Monitor stablecoins for abnormal social engagement spikes or negative sentiment -- early warning for depeg risk."
    },
    {
      "title": "\nTrack Consumer Brand Social Rankings\n",
      "audience": "\nEnterprise, Marketers\n",
      "dataType": "\nRankings\n",
      "assetClass": "\nStocks\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Beginner",
      "methods": {
        "discover": "\nlunarcrush.com/home > Categories > Consumer Brands\n",
        "claude": "\nWhich consumer brands are driving the most social conversation right now?\n",
        "claudeCode": "\nList(category='consumer-brands', sort='interactions', limit=20)\n",
        "api": "\nGET /category/consumer-brands/topics/v1\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=consumer-brands",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/category/consumer-brands/topics/v1\n",
      "primaryMetric": "\nInteractions\n",
      "tags": "\nconsumer, brand, nike, apple, retail, marketing-intelligence\n",
      "order": 124,
      "description": "Track Nike, Apple, Starbucks, and other consumer brands by social engagement and sentiment."
    },
    {
      "title": "\nMonitor VC and Fund Social Activity\n",
      "audience": "\nInvestors, Enterprise\n",
      "dataType": "\nRankings\n",
      "assetClass": "\nCrypto, Stocks\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "\nlunarcrush.com/home > Categories > Venture Capital\n",
        "claude": "\nWhich VC firms and crypto funds are generating the most social buzz?\n",
        "claudeCode": "\nList(category='venture-capital', sort='interactions', limit=20)\n",
        "api": "\nGET /category/venture-capital/topics/v1\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?category=venture-capital",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/category/venture-capital/topics/v1\n",
      "primaryMetric": "\nInteractions\n",
      "tags": "\nvc, venture-capital, smart-money, institutional, funds\n",
      "order": 125,
      "description": "Track Andreessen Horowitz, Paradigm, Sequoia and other VCs by social activity to gauge where smart money attention is flowing."
    },
    {
      "title": "\nTrack Political Topic Social Sentiment\n",
      "audience": "\nEnterprise, Investors\n",
      "dataType": "\nSentiment\n",
      "assetClass": "\nAny\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "\nlunarcrush.com > Search any political topic > Sentiment tab\n",
        "claude": "\nHow is social sentiment shifting around key political topics that affect markets?\n",
        "claudeCode": "\nTopic(topic='trump') > sentiment\n",
        "api": "\nGET /topic/trump/v1\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=trump",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/topic/trump/v1\n",
      "primaryMetric": "\nSentiment\n",
      "tags": "\npolitics, policy, macro, regulatory-risk, sentiment-shift\n",
      "order": 126,
      "description": "Monitor sentiment around political figures and policy topics that drive crypto and equity market volatility."
    },
    {
      "title": "\nFind Tokens with Most Developer Community Buzz\n",
      "audience": "\nInvestors, Builders\n",
      "dataType": "\nSentiment\n",
      "assetClass": "\nCrypto\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Advanced",
      "methods": {
        "discover": "\nlunarcrush.com > Compare contributor counts across topics\n",
        "claude": "\nWhich crypto projects have the most active and growing developer and community conversation?\n",
        "claudeCode": "\nTopic(topic='ethereum') > contributors_active -- compare across projects\n",
        "api": "\nGET /topic/{symbol}/v1 > contributors_active\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=ethereum",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/topic/ethereum/v1\n",
      "primaryMetric": "\nContributors Active\n",
      "tags": "\ndeveloper-community, contributor-breadth, organic-growth, fundamentals\n",
      "order": 127,
      "description": "Identify projects with high contributor breadth -- sign of genuine community vs concentrated narrative."
    },
    {
      "title": "\nTrack Social Engagement for ETF Issuers\n",
      "audience": "\nInvestors, Enterprise\n",
      "dataType": "\nSentiment\n",
      "assetClass": "\nStocks\n",
      "workflow": "\nResearch\n",
      "skillLevel": "Intermediate",
      "methods": {
        "discover": "\nlunarcrush.com > Search 'BlackRock' or 'Fidelity' > Topic page\n",
        "claude": "\nHow much social attention are major ETF issuers like BlackRock and Fidelity getting around crypto products?\n",
        "claudeCode": "\nTopic(topic='blackrock') > interactions\n",
        "api": "\nGET /topic/blackrock/v1\n"
      },
      "discoverUrl": "https://lunarcrush.com/home?topic=blackrock",
      "apiUrl": "\nhttps://lunarcrush.com/developers/api/public/topic/blackrock/v1\n",
      "primaryMetric": "\nInteractions\n",
      "tags": "\netf, blackrock, fidelity, institutional, asset-manager, bitcoin-etf\n",
      "order": 128,
      "description": "Monitor social engagement for asset managers launching Bitcoin and crypto ETFs -- proxy for institutional inflow sentiment."
    }
  ],
  "pricingPlans": [
    {
      "name": "Hobby",
      "description": "Pay-as-you-go: an API key with 1,000 credits to start, then $1 per 1,000 requests across the API, MCP, and CLI. The LunarCrush Discover app comes with a subscription.",
      "price": "",
      "priceLabel": "$1 per 1,000 requests",
      "ctaLabel": "GET API KEY",
      "accentColor": "white",
      "features": [
        {
          "title": "LunarCrush Discover",
          "description": "Comes with a subscription"
        },
        {
          "title": "LunarCrush + LLMs",
          "description": "All tools, billed per request"
        },
        {
          "title": "LunarCrush API",
          "description": "All endpoints, 10 requests/min, billed per request"
        },
        {
          "title": "LunarCrush CLI",
          "description": "Access with credits"
        },
        {
          "title": "LunarCrush Collections",
          "description": "0 collections"
        },
        {
          "title": "LunarCrush MCP Server",
          "description": "All tools within API limits"
        },
        {
          "title": "LunarCrush Apps",
          "description": "Comes with a subscription"
        },
        {
          "title": "Support",
          "description": "Community support"
        }
      ],
      "order": 0
    },
    {
      "name": "Individual",
      "description": "Real-time social media sentiment via MCP, API, and Discover for crypto, stocks, and more. Bring social data into your AI workflows.",
      "price": "$72",
      "ctaLabel": "SUBSCRIBE",
      "accentColor": "amber",
      "features": [
        {
          "title": "LunarCrush Discover",
          "description": "Single user + one friend"
        },
        {
          "title": "LunarCrush + LLMs",
          "description": "Connect directly to Claude and ChatGPT"
        },
        {
          "title": "LunarCrush API",
          "description": "All endpoints, 10 requests/min, 2,000/day"
        },
        {
          "title": "LunarCrush CLI",
          "description": "Access within API limits"
        },
        {
          "title": "LunarCrush Collections",
          "description": "1 collection"
        },
        {
          "title": "LunarCrush MCP Server",
          "description": "All tools within API limits"
        },
        {
          "title": "LunarCrush Apps",
          "description": "Get the Fantasy Sports app"
        },
        {
          "title": "Support",
          "description": "Support portal"
        }
      ],
      "order": 1
    },
    {
      "name": "Builder",
      "description": "Every endpoint, advanced MCP integrations, and Custom Collections for teams building with social data.",
      "price": "$240",
      "ctaLabel": "SUBSCRIBE",
      "accentColor": "cyan",
      "features": [
        {
          "title": "LunarCrush Discover",
          "description": "Shared team access, up to 5 seats"
        },
        {
          "title": "LunarCrush + LLMs",
          "description": "Connect directly to Claude and ChatGPT"
        },
        {
          "title": "LunarCrush API",
          "description": "All endpoints, 100 requests/min, 20,000/day"
        },
        {
          "title": "LunarCrush CLI",
          "description": "Access within API limits"
        },
        {
          "title": "LunarCrush Collections",
          "description": "Up to 100 collections, priority processing"
        },
        {
          "title": "LunarCrush MCP Server",
          "description": "All tools within API limits"
        },
        {
          "title": "LunarCrush Apps",
          "description": "Get the Fantasy Sports app"
        },
        {
          "title": "Support",
          "description": "Priority support: 24-hour response via email/chat, weekday business hours"
        }
      ],
      "order": 2
    },
    {
      "name": "Scale",
      "description": "Everything in Medium with higher rate limits, deeper Collections, and priority support for production-grade social media sentiment.",
      "price": "$720",
      "ctaLabel": "SUBSCRIBE",
      "accentColor": "green",
      "features": [
        {
          "title": "LunarCrush Discover",
          "description": "Shared team access, up to 10 seats"
        },
        {
          "title": "LunarCrush + LLMs",
          "description": "Connect directly to Claude and ChatGPT"
        },
        {
          "title": "LunarCrush API",
          "description": "All endpoints, 500 requests/min, 100,000/day"
        },
        {
          "title": "LunarCrush CLI",
          "description": "Access within API limits"
        },
        {
          "title": "LunarCrush Collections",
          "description": "Up to 300 collections, priority processing"
        },
        {
          "title": "LunarCrush MCP Server",
          "description": "All tools within API limits"
        },
        {
          "title": "LunarCrush Apps",
          "description": "Get the Fantasy Sports app"
        },
        {
          "title": "Support",
          "description": "Premium support: 4-hour response via email/chat/phone, fastest response rate"
        }
      ],
      "order": 3
    },
    {
      "name": "Enterprise",
      "description": "Built for enterprise teams, customizable to your brand. Track real-time social trends, key voices, and market-moving narratives.",
      "price": "",
      "priceLabel": "Custom Pricing",
      "priceNote": "Custom API request limits based on needs",
      "ctaLabel": "GET PRICING",
      "accentColor": "purple",
      "features": [
        {
          "title": "LunarCrush Discover",
          "description": "Organization access"
        },
        {
          "title": "LunarCrush + LLMs",
          "description": "Connect directly to Claude and ChatGPT"
        },
        {
          "title": "LunarCrush API",
          "description": "Custom"
        },
        {
          "title": "LunarCrush CLI",
          "description": "Access within API limits"
        },
        {
          "title": "LunarCrush Collections",
          "description": "Custom"
        },
        {
          "title": "LunarCrush MCP Server",
          "description": "Custom"
        },
        {
          "title": "LunarCrush Apps",
          "description": "Get the Fantasy Sports app"
        },
        {
          "title": "Support",
          "description": "Custom"
        }
      ],
      "highlights": [
        {
          "title": "API Customization",
          "icon": "code",
          "color": "green",
          "desc": "Custom API solutions tailored to fit your data needs, integrations, and workflows."
        },
        {
          "title": "Consulting",
          "icon": "lightbulb",
          "color": "amber",
          "desc": "Expert consulting for API integrations, helping teams design and optimize custom solutions."
        },
        {
          "title": "Available SLAs",
          "icon": "sparkle",
          "color": "cyan",
          "desc": "Service level agreements ensuring guaranteed uptime, priority support, and performance standards."
        },
        {
          "title": "Integrations",
          "icon": "globe",
          "color": "green",
          "desc": "Enterprise-ready API integrations to connect real-time social data to your existing applications."
        },
        {
          "title": "Team Access",
          "icon": "users",
          "color": "purple",
          "desc": "Team access to LunarCrush, enabling multiple users to monitor data across departments."
        },
        {
          "title": "Priority Support",
          "icon": "shieldCheck",
          "color": "cyan",
          "desc": "Personalized onboarding and ongoing technical assistance for a seamless experience."
        }
      ],
      "order": 4
    }
  ],
  "navigation": [
    {
      "label": "Investors & Traders",
      "type": "dropdown_child",
      "parent": "Use Cases",
      "order": 1
    },
    {
      "label": "Platform",
      "type": "dropdown_parent",
      "order": 1
    },
    {
      "label": "LunarCrush Discover",
      "type": "dropdown_child",
      "parent": "Platform",
      "order": 1
    },
    {
      "label": "Developers & Builders",
      "type": "dropdown_child",
      "parent": "Use Cases",
      "order": 2
    },
    {
      "label": "Pricing",
      "type": "link",
      "order": 2
    },
    {
      "label": "LunarCrush API",
      "type": "dropdown_child",
      "parent": "Platform",
      "order": 2
    },
    {
      "label": "Enterprise & Funds",
      "type": "dropdown_child",
      "parent": "Use Cases",
      "order": 3
    },
    {
      "label": "Enterprise",
      "type": "link",
      "order": 3
    },
    {
      "label": "LunarCrush MCP",
      "type": "dropdown_child",
      "parent": "Platform",
      "order": 3
    },
    {
      "label": "LunarCrush CLI",
      "type": "dropdown_child",
      "parent": "Platform",
      "order": 4
    },
    {
      "label": "Use Cases",
      "type": "link",
      "order": 4
    },
    {
      "label": "Blog",
      "type": "link",
      "order": 5
    },
    {
      "label": "LunarCrush Collections",
      "type": "dropdown_child",
      "parent": "Platform",
      "order": 5
    },
    {
      "label": "LunarCrush + Claude",
      "type": "dropdown_child",
      "parent": "Platform",
      "order": 6
    },
    {
      "label": "LunarCrush + ChatGPT",
      "type": "dropdown_child",
      "parent": "Platform",
      "order": 7
    },
    {
      "label": "Log in",
      "type": "login",
      "order": 99
    },
    {
      "label": "Sign Up",
      "type": "cta",
      "order": 100
    }
  ],
  "footerColumns": [
    {
      "title": "Platform",
      "links": [
        "LunarCrush + Claude",
        "LunarCrush API",
        "LunarCrush MCP",
        "LunarCrush CLI",
        "LunarCrush Discover",
        "LunarCrush Collections"
      ]
    },
    {
      "title": "Company",
      "links": [
        "About",
        "Careers",
        "FAQs",
        "Shop",
        "Brand Resources"
      ]
    }
  ],
  "footerSocialLinks": [
    "X",
    "Telegram",
    "YouTube",
    "Instagram"
  ],
  "faqs": [],
  "blogPosts": []
};
export default data;
